import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
// import HSE_Cover_New from "../../HSE_Report_Cover.png";
// import HSE_Cover_New from "../../HSE PNG.png";
// import HSE_Cover_New from "../../HSEPortrait.png";
import HSE_Cover_New from "../../HSE2026_PNG.png";
// import Electrical_Cover_New from "../../Electrical PNG.png";
// import Electrical_Cover_New from "../../ElectricalPortrait.png";
import Electrical_Cover_New from "../../Electrical2026_PNG.png";
// import Electrical_Cover_New from "../../Electrical_Safety_Report_Cover.png";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  LevelFormat,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  AlignmentType,
  ExternalHyperlink,
  Footer,
  PageNumber,
  NumberFormat,
  BorderStyle,
  PageOrientation,
  VerticalAlign,
  SectionType,
  ShadingType,
  TableLayoutType,
  HeightRule,
  TabStopType,
} from "docx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import axios from "../../APIs/axios";
import { config } from "../../config";
import logo from "../../mi_logo_report.png";
import HTMLReactParser from 'html-react-parser';
import htmlDocx from "html-docx-js/dist/html-docx";
import { margin } from "@mui/system";

const imageToBase64 = async (url) => {

  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.log("Error:", error.message)
  }
};

// Helper to calculate responsive image dimensions based on column size
const getResponsiveImageDimensions = (columnWidthInInches, numImages = 1, baseRowHeightInches = 1.5) => {
  const DPI = 96;
  const maxWidth = Math.floor(columnWidthInInches * DPI * 0.95);

  // Max height per image (prevent excessive row growth)
  const maxHeightPerImage = Math.floor(1.2 * DPI); // 1.2 inches max per image

  // Minimum height per image to maintain readability (similar to PDF's 80px)
  const minHeightPerImage = Math.floor(0.8 * DPI); // 0.8 inches minimum (~77px)

  // Base height for single image
  let targetHeight = Math.floor(baseRowHeightInches * DPI * 0.6);

  // If 2+ images, cap the effective number of images at 6 to prevent excessive shrinking
  // This ensures images maintain minimum dimensions even with many images
  if (numImages >= 2) {
    const effectiveNumImages = Math.min(numImages, 6);
    targetHeight = Math.min(
      Math.floor((baseRowHeightInches * 1.3) / effectiveNumImages * DPI),
      maxHeightPerImage
    );

    // Ensure minimum height is maintained
    targetHeight = Math.max(targetHeight, minHeightPerImage);
  }

  // Width based on 16:10 aspect ratio
  const widthBasedHeight = Math.floor(maxWidth * 0.625);

  // Use smaller of constraints but ensure minimum height
  const finalHeight = Math.max(Math.min(targetHeight, widthBasedHeight, maxHeightPerImage), minHeightPerImage);
  const finalWidth = Math.min(Math.floor(finalHeight * 1.6), maxWidth);

  return { width: finalWidth, height: finalHeight };
};

// Reads an image's intrinsic pixel size straight from its base64 bytes (JPEG or
// PNG) so it can be scaled without distorting its aspect ratio. Works on raw
// base64 or a data: URL. Returns null when the format isn't recognised, and
// callers fall back to the default sizing.
const getBase64ImageSize = (base64) => {
  try {
    if (!base64 || typeof base64 !== "string") return null;
    const comma = base64.indexOf(",");
    const raw = comma >= 0 ? base64.slice(comma + 1) : base64;
    const bin = atob(raw);
    const len = bin.length;
    const at = (i) => bin.charCodeAt(i);

    // PNG: 8-byte signature, then the IHDR chunk holds width/height as 32-bit
    // big-endian integers at byte offsets 16 and 20.
    if (len > 24 && at(0) === 0x89 && at(1) === 0x50) {
      const width = (at(16) << 24) | (at(17) << 16) | (at(18) << 8) | at(19);
      const height = (at(20) << 24) | (at(21) << 16) | (at(22) << 8) | at(23);
      if (width > 0 && height > 0) return { width, height };
    }

    // JPEG: walk the marker segments until the Start-Of-Frame, which carries the
    // frame's height then width as 16-bit big-endian values.
    if (len > 4 && at(0) === 0xff && at(1) === 0xd8) {
      let offset = 2;
      while (offset + 9 < len) {
        if (at(offset) !== 0xff) {
          offset++;
          continue;
        }
        const marker = at(offset + 1);
        // SOF0–SOF15 hold the dimensions; skip the non-SOF markers in that range.
        if (
          marker >= 0xc0 &&
          marker <= 0xcf &&
          marker !== 0xc4 &&
          marker !== 0xc8 &&
          marker !== 0xcc
        ) {
          const height = (at(offset + 5) << 8) | at(offset + 6);
          const width = (at(offset + 7) << 8) | at(offset + 8);
          if (width > 0 && height > 0) return { width, height };
          break;
        }
        const segLen = (at(offset + 2) << 8) | at(offset + 3);
        if (segLen <= 0) break;
        offset += 2 + segLen;
      }
    }
  } catch (e) {
    // Unparseable — fall through to the default sizing.
  }
  return null;
};

// Scales an image to fit a column while keeping its real aspect ratio (so it
// never gets stretched or squashed). Width is bounded by the column, height by a
// per-image cap that shrinks as more images share the cell. Falls back to the
// fixed-ratio box when the intrinsic size can't be read.
const getAspectFitDimensions = (base64, columnWidthInInches, numImages = 1) => {
  const DPI = 96;
  const maxWidth = Math.floor(columnWidthInInches * DPI * 0.95);

  let maxHeight = Math.floor(1.2 * DPI); // 1.2" cap for a single image
  if (numImages >= 2) {
    const effective = Math.min(numImages, 6);
    maxHeight = Math.max(
      Math.floor((1.2 / effective) * 1.3 * DPI),
      Math.floor(0.8 * DPI) // keep a readable minimum
    );
  }

  const natural = getBase64ImageSize(base64);
  if (!natural) {
    return getResponsiveImageDimensions(columnWidthInInches, numImages);
  }

  const scale = Math.min(maxWidth / natural.width, maxHeight / natural.height);
  return {
    width: Math.max(1, Math.round(natural.width * scale)),
    height: Math.max(1, Math.round(natural.height * scale)),
  };
};

// Helper to convert table-cell text (observation / recommendation) to paragraphs.
// The text is stored plain with literal bullet glyphs (•, ◦, ▪, ‣) — one per
// newline or several glued together. Lines that start with a bullet glyph become
// proper bullet paragraphs; the marker is normalized to the • disc because the
// Montserrat font only contains • (◦/▪/‣ render inconsistently / as "æ" in PDF).
const textToBulletParagraphs = (text) => {
  if (!text) return [new Paragraph({ children: [new TextRun("N/A")] })];

  const bulletRe = /^\s*([•◦▪‣])\s*([\s\S]*)$/;
  const baseIndent = 200; // small hanging indent so wrapped lines align; fits table cells
  const paras = [];

  // Keep the glyph while splitting so its nesting depth can be inferred (• L1,
  // ◦ L2, ▪/‣ L3). The marker itself is the font-safe •; the text is made
  // font-safe so any leftover glyph in the body doesn't render as "æ".
  String(text).split("\n").forEach((rawLine) => {
    if (!rawLine.trim()) return;
    // Split before each bullet glyph so several bullets glued on one line separate.
    rawLine.split(/(?=[•◦▪‣])/).forEach((part) => {
      if (!part.trim()) return;
      const m = part.match(bulletRe);
      if (m && m[2].trim()) {
        const leftIndent = baseIndent + glyphDepth(m[1]) * 220; // deeper glyph → more indent
        paras.push(
          new Paragraph({
            children: [
              new TextRun({ text: "•\t", bold: true }),
              new TextRun(toFontSafeBullets(m[2].trim())),
            ],
            spacing: { after: 100 },
            indent: { left: leftIndent, hanging: baseIndent },
            tabStops: [{ type: TabStopType.LEFT, position: leftIndent }],
          })
        );
      } else {
        paras.push(
          new Paragraph({
            children: [new TextRun(toFontSafeBullets(part.trim()))],
            spacing: { after: 100 },
          })
        );
      }
    });
  });

  if (paras.length === 0) return [new Paragraph({ children: [new TextRun("N/A")] })];
  return paras;
};

const riskLevels = [
  {
    range: "≥ 85%",
    risk: "Low Risk",
    color: "#00A651",
    interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
  },
  {
    range: "65% – 84%",
    risk: "Medium Risk",
    color: "#FFFF00",
    interpretation: "Controls are adequate but with noticeable weaknesses.",
  },
  {
    range: "25% – 64%",
    risk: "High Risk",
    color: "#FFA500",
    interpretation: "High vulnerabilities with major compliance gaps.",
  },
  {
    range: "< 25%",
    risk: "Severe Risk",
    color: "#FF0000",
    interpretation: "Controls are ineffective, urgent corrective action required.",
  },
];

const getDaySuffix = (day) => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
};
const createBreaks = (num) => {
  const breaks = [];
  for (let i = 0; i < num; i++) {
    breaks.push(new Paragraph({ break: 1 }));
  }
  return breaks;
};
// Convert rgb(...) to hex

const sanitizeHtml = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Remove Jodit selection marker spans
  doc.querySelectorAll('span[data-jodit-selection_marker]').forEach((el) => el.remove());

  return doc.body.innerHTML;
};

// The editor saves bullet points as literal glyph characters (•, ◦, ▪, ‣) inside
// <p>/<br> markup rather than as a real <ul>, so Word rendered them as one run-on
// paragraph. Convert those <p> blocks into proper <ul><li> lists so the export
// matches the saved report. The original glyph is recorded on a data-bullet
// attribute (informational only — the rendered marker is normalized to the •
// disc because the Montserrat font lacks the ◦/▪/‣ glyphs).
const WORD_BULLET_CHARS = "•◦▪‣";
// The report uses the Montserrat font, which only contains the • (U+2022) glyph.
// Replace any other bullet glyph the editor saved (◦ ▪ ‣ ○) with • so the marker
// is consistent across Word and PDF and never depends on Word font substitution.
const toFontSafeBullets = (html) => (html || "").replace(/[◦▪‣○∙]/g, "•");

// Map a bullet glyph to a nesting depth. The editor often saves multi-level
// bullets as FLAT text (• level 1, ◦ level 2, ▪/‣ level 3) rather than real
// nested <ul>s, so the glyph itself is the only signal of how deep an item is.
const glyphDepth = (g) => (g === "◦" ? 1 : g === "▪" || g === "‣" ? 2 : 0);

const normalizeBullets = (html) => {
  if (!html) return html;
  const bulletClass = `[${WORD_BULLET_CHARS}]`;

  return html.replace(/<p\b[^>]*>([\s\S]*?)<\/p>/gi, (whole, inner) => {
    if (!new RegExp(bulletClass).test(inner)) return whole; // no bullets → leave as-is

    // Split into lines on <br>, then before each bullet glyph so several bullets
    // crammed into one paragraph become separate items.
    const segments = inner
      .split(/<br\s*\/?>/i)
      .flatMap((seg) => seg.split(new RegExp(`(?=${bulletClass})`)));

    let leading = ""; // text before the first bullet stays a normal paragraph
    const items = [];
    for (const seg of segments) {
      const m = seg.match(new RegExp(`^\\s*(${bulletClass})\\s*([\\s\\S]*)$`));
      if (m) {
        const text = m[2].trim();
        // Keep each item's own glyph so its nesting depth can be recovered.
        if (text) items.push({ glyph: m[1], text });
      } else if (seg.trim()) {
        leading += seg;
      }
    }
    if (items.length === 0) return whole;

    const leadHtml = leading.trim() ? `<p>${leading.trim()}</p>` : "";
    const lis = items
      .map((it) => `<li data-bullet="${it.glyph}">${it.text}</li>`)
      .join("");
    return `${leadHtml}<ul>${lis}</ul>`;
  });
};


const convertNodeToRuns = (node, inheritedStyles = {}) => {
  let runs = [];

  if (node.nodeType === Node.TEXT_NODE) {
    // Swap any non-• bullet glyph that survived as inline text to the font-safe •.
    const text = toFontSafeBullets(node.textContent);
    if (text) {
      runs.push(
        new TextRun({
          text,
          bold: inheritedStyles.bold,
          italics: inheritedStyles.italics,
          underline: inheritedStyles.underline ? {} : undefined,
          font: inheritedStyles.font || "Montserrat",
          // size: inheritedStyles.size,
          size: inheritedStyles.size || 22,
        })
      );
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    const tag = node.tagName.toLowerCase();
    const newStyles = { ...inheritedStyles };
    if (
      tag === "span" &&
      node.getAttribute("data-jodit-selection_marker") &&
      node.getAttribute("data-jodit-temp") === "true"
    ) {
      runs.push(new TextRun({ break: 1 }));
      return runs;
    }

    if (tag === "b" || tag === "strong") newStyles.bold = true;
    if (tag === "i" || tag === "em") newStyles.italics = true;
    if (tag === "u") newStyles.underline = true;
    if (tag === "br") {
      runs.push(new TextRun({ break: 1 }));
      return runs;
    }

    if (tag === "span") {
      const style = node.getAttribute("style") || "";
      const fontSizeMatch = style.match(/font-size:\s*(\d+)px/);
      const fontFamilyMatch = style.match(/font-family:\s*([^;]+)/i);

      if (fontSizeMatch) {
        const px = parseInt(fontSizeMatch[1], 10);
        newStyles.size = px * 2; // DOCX size is half-points
      }

      if (fontFamilyMatch) {
        newStyles.font = fontFamilyMatch[1].trim().replace(/['"]/g, "");
      }
    }

    for (const child of node.childNodes) {
      runs = runs.concat(convertNodeToRuns(child, newStyles));
    }
  }

  return runs;
};

const splitLiContent = (liNode) => {
  const textParts = [];
  const nestedLists = [];

  liNode.childNodes.forEach((child) => {
    if (
      child.nodeType === 1 &&
      (child.tagName.toLowerCase() === "ul" || child.tagName.toLowerCase() === "ol")
    ) {
      nestedLists.push(child);
    } else {
      textParts.push(child);
    }
  });

  return { textParts, nestedLists };
};

const convertHtmlToParagraphs = (htmlString) => {
  // Keep bullet glyphs intact here so normalizeBullets can record each item's
  // depth; the font-safe • swap happens in convertNodeToRuns / the marker below.
  const cleanHtml = normalizeBullets(sanitizeHtml(htmlString));
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleanHtml, "text/html");

  const paragraphs = [];

  // Recursively render a <ul>/<ol>; deeper levels indent further so nested
  // bullets keep their hierarchy (Word has no auto-nesting from flat <li>s).
  const processList = (listNode, level = 0) => {
    const isOrdered = listNode.tagName.toLowerCase() === "ol";
    // Always draw the • disc. The report references the Montserrat font, which
    // only contains • (U+2022); ◦ / ▪ / ‣ aren't in it and render inconsistently
    // (and as "æ" in the PDF export), so use • for a reliable, matching marker.
    const bulletGlyph = "•";
    // Direct-child <li> only, so nested lists aren't double-counted.
    const listItems = Array.from(listNode.children).filter(
      (el) => el.tagName.toLowerCase() === "li"
    );

    listItems.forEach((li, index) => {
      const { textParts, nestedLists } = splitLiContent(li);
      const hasText = textParts.some(
        (n) => (n.textContent || "").trim().length > 0
      );

      if (hasText) {
        // Flat literal bullets carry their level in data-bullet (◦ = +1, ▪ = +2),
        // so the item indents to the right depth even without real <ul> nesting.
        const liGlyph = li.getAttribute("data-bullet");
        const itemLevel = level + (liGlyph ? glyphDepth(liGlyph) : 0);
        // The left indent of the text. Wrapped lines align here, and the tab
        // stop below pushes the first line's text to the exact same position
        // so wrapping looks like the PDF (no extra space on wrapped lines).
        const leftIndent = 720 + itemLevel * 360;
        // Ordered numbers and bullets need different marker layouts.
        //
        // For numbers we right-align the marker in its own column and snap the
        // text to a fixed left tab stop. That way "9." and "10." share the exact
        // same text column and the numbers line up by their period — single- and
        // two-digit items never drift (the old single-left-tab approach pushed
        // two-digit rows out of line). This is how Word renders a native list.
        //
        // For bullets we keep a small hanging gap so the • sits next to the text.
        let markerText, markerIndent, markerTabStops;
        if (isOrdered) {
          const textPos = leftIndent;            // every item's text lines up here
          const numberRight = leftIndent - 120;  // period/right edge of the number
          // Leading tab → right tab stop (right-aligns the number); trailing tab
          // → left tab stop (drops the text at the shared column).
          markerText = `\t${index + 1}.\t`;
          markerIndent = { left: textPos, hanging: 600 };
          markerTabStops = [
            { type: TabStopType.RIGHT, position: numberRight },
            { type: TabStopType.LEFT, position: textPos },
          ];
        } else {
          markerText = `${bulletGlyph}\t`;
          markerIndent = { left: leftIndent, hanging: 180 };
          markerTabStops = [{ type: TabStopType.LEFT, position: leftIndent }];
        }

        const runs = [
          new TextRun({
            text: markerText,
            bold: !isOrdered,  // numbers regular weight, bullet glyph bold
            size: 22,
            font: "Montserrat",
          }),
        ];

        // Convert the item's own content (nested lists excluded).
        textParts.forEach((child) => {
          runs.push(...convertNodeToRuns(child));
        });

        paragraphs.push(
          new Paragraph({
            children: runs,
            spacing: {
              after: 160, // 8pt = 160 twips
              line: 276,  // 1.08 lines = 276 twips
              lineRule: "auto",
            },
            indent: markerIndent,
            tabStops: markerTabStops,
          })
        );
      }

      // Nested lists render one level deeper, after the parent bullet.
      nestedLists.forEach((nested) => processList(nested, level + 1));
    });
  };

  doc.body.childNodes.forEach((node) => {
    const tag = node.nodeType === 1 ? node.tagName.toLowerCase() : "";

    if (tag === "ul" || tag === "ol") {
      processList(node, 0);
    } else {
      const runs = [];
      node.childNodes.forEach((child) => {
        runs.push(...convertNodeToRuns(child));  // Convert non-list elements to runs
      });

      if (runs.length > 0) {
        // paragraphs.push(new Paragraph({ children: runs }));
        paragraphs.push(
          new Paragraph({
            children: runs,
            spacing: {
              after: 160, // 8pt = 160 twips
              line: 276,  // 1.08 lines = 276 twips
              lineRule: "auto",
            },
            indent: {
              left: 0,
              right: 0,
              firstLine: 0,
            },
          })
        );

      }
    }
  });

  return paragraphs;
};

// const convertHtmlToParagraphs = (htmlString) => {
//   const cleanHtml = sanitizeHtml(htmlString);
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(cleanHtml, "text/html");

//   const paragraphs = [];

//   const processList = (node, level = 0) => {
//     const isOrdered = node.tagName.toLowerCase() === "ol";
//     const listItems = node.querySelectorAll(":scope > li");

//     listItems.forEach((li, index) => {
//       const { textParts, nestedLists } = splitLiContent(li);

//       const runs = [];

//       // bullet or number
//       runs.push(
//         new TextRun({
//           text: isOrdered ? `${index + 1}. ` : "• ",
//           bold: !isOrdered,
//           size: 22,
//           font: "Montserrat",
//         })
//       );

//       // LI main text (exclude nested lists)
//       textParts.forEach((child) => {
//         runs.push(...convertNodeToRuns(child));
//       });

//       // Create paragraph for THIS menu item
//       paragraphs.push(
//         new Paragraph({
//           children: runs,
//           spacing: {
//             after: 160,
//             line: 276,
//             lineRule: "auto",
//           },
//           indent: {
//             left: 360 + level * 360,
//             hanging: 360,
//           },
//         })
//       );

//       // Process nested lists recursively
//       nestedLists.forEach((nested) => {
//         processList(nested, level + 1);
//       });
//     });
//   };

//   // MAIN BODY
//   doc.body.childNodes.forEach((node) => {
//     if (node.nodeType !== 1) return;

//     const tag = node.tagName.toLowerCase();

//     if (tag === "ul" || tag === "ol") {
//       processList(node, 0);
//     } else {
//       // Normal paragraphs
//       const runs = [];
//       node.childNodes.forEach((child) => {
//         runs.push(...convertNodeToRuns(child));
//       });

//       if (runs.length > 0) {
//         paragraphs.push(
//           new Paragraph({
//             children: runs,
//             spacing: {
//               after: 160,
//               line: 276,
//               lineRule: "auto",
//             },
//             indent: {
//               left: 0,
//               right: 0,
//               firstLine: 0,
//             },
//           })
//         );
//       }
//     }
//   });

//   return paragraphs;
// };

const convertHtmlToParagraphsForImprovementOpportunityAreas = (htmlString) => {
  // Keep bullet glyphs intact so normalizeBullets can record each item's depth.
  const cleanHtml = normalizeBullets(sanitizeHtml(htmlString));
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleanHtml, "text/html");

  const paragraphs = [];

  // Recursively render a <ul>/<ol>; deeper levels indent further so nested
  // bullets keep their hierarchy (Word has no auto-nesting from flat <li>s).
  const processList = (listNode, level = 0) => {
    const isOrdered = listNode.tagName.toLowerCase() === "ol"; // Check if it's an ordered list (ol)
    // Always draw the • disc — Montserrat only contains • (see HSE converter).
    const bulletGlyph = "•";
    // Direct-child <li> only, so nested lists aren't double-counted.
    const listItems = Array.from(listNode.children).filter(
      (el) => el.tagName.toLowerCase() === "li"
    );

    listItems.forEach((li, index) => {
      const { textParts, nestedLists } = splitLiContent(li);
      const hasText = textParts.some(
        (n) => (n.textContent || "").trim().length > 0
      );

      if (hasText) {
        // Flat literal bullets carry their level in data-bullet (◦ = +1, ▪ = +2).
        const liGlyph = li.getAttribute("data-bullet");
        const itemLevel = level + (liGlyph ? glyphDepth(liGlyph) : 0);
        // Same hanging-indent + tab-stop layout as the HSE converter so the
        // marker sits beside the text and wrapped lines align under the text.
        const leftIndent = 720 + itemLevel * 360;
        const markerGap = 180;

        const runs = [
          new TextRun({
            text: isOrdered ? `${index + 1}.\t` : `${bulletGlyph}\t`,
            bold: !isOrdered,
            size: 22,
            font: "Montserrat",
          }),
        ];

        // Convert the item's own content (nested lists excluded).
        textParts.forEach((child) => {
          runs.push(...convertNodeToRuns(child)); // Recursive conversion of child nodes
        });

        // Add paragraph
        paragraphs.push(
          new Paragraph({
            children: runs,
            spacing: {
              after: 160, // 8pt = 160 twips
              line: 276,  // 1.08 lines = 276 twips
              lineRule: "auto",
            },
            indent: {
              left: leftIndent, // deeper levels indent further
              hanging: markerGap, // small gap = bullet sits next to the text
            },
            tabStops: [{ type: TabStopType.LEFT, position: leftIndent }],
          })
        );
      }

      // Nested lists render one level deeper, after the parent bullet.
      nestedLists.forEach((nested) => processList(nested, level + 1));
    });
  };

  doc.body.childNodes.forEach((node) => {
    const tag = node.nodeType === 1 ? node.tagName.toLowerCase() : "";

    if (tag === "ul" || tag === "ol") {
      processList(node, 0);
    } else {
      const runs = [];
      node.childNodes.forEach((child) => {
        runs.push(...convertNodeToRuns(child)); // Convert non-list elements to runs
      });

      if (runs.length > 0) {
        paragraphs.push(
          new Paragraph({
            children: runs,
            spacing: {
              after: 160,
              line: 276,
              lineRule: "auto",
            },
            indent: {
              left: 0,
              right: 0,
              firstLine: 0,
            },
          })
        );
      }
    }
  });

  return paragraphs;
};

const ExportWordDoc = ({
  backgroundBrief,
  improvementOpportunityAreas,
  overallAssessmentIndicator,
  contents,
  isSaved,
  exeSummary,
  exeSummaryFindigs,
  exeSummaryKeyObservations,
  criticalObservations,
  selectedObservations,
  scores,
  cumulativeScore,
  conclusion,
  // imageUrlsByRow,
  selectedDateTime,
  selectedOrganization,
  selectedSite,
  selectedState,
  otherDetails,
  reportType,
  chartImageElectrical,
  chartImage,
  scorePercent = 0,
  ReportUID,
  bestPractice,
  theWayForward,
  startDate,
  endDate,
  name,
  facilityInfo,
  introduction,
  timeFrom,
  timeTo,
  briefPropertyDescription,
  numOfFloors,
  avgStaffFootfall,
  noObjectionCertificate,
  nationalBuildingCodeCategory,
  coordinationgPersonClientside,
  reportPreparedBy,
  reportReviewedBy,
  buildingName,
  classificationOfAuditObservations,
  auditScoreAnalysis,
  references
  // gaugeImageWord,

}) => {
  // console.log("image",gaugeImageWord)
  //   console.log("guage",gaugeImageWord)
  // console.log("chart",chartImageElectrical)
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageHSE, setCoverImageHSE] = useState(null);
  const [base64logo, setBase64Logo] = useState(null)
  const [selectedObsCopy, setSelectedObsCopy] = useState([
    ...selectedObservations,
  ]);
  const [loading, setLoading] = useState(false);

  const groupedObservations = selectedObsCopy.reduce((acc, observation) => {
    const { table_type } = observation;
    if (reportType == "HSE") {
      // Ensure table_type is defined and not null or an empty string
      if (table_type) {
        if (!acc[table_type]) {
          acc[table_type] = [];
        }
        acc[table_type].push(observation);
      } else {
        console.warn("Observation without a valid table_type:", observation);
      }
    }
    return acc;
  }, {});
  // let boxColor = "#FFD700"; // default yellow
  // if (cumulativeScore >= 8.5) {
  //   boxColor = "#00A651"; // Low Risk
  // } else if (cumulativeScore >= 6.5) {
  //   boxColor = "#FFFF00"; // Medium Risk
  // } else if (cumulativeScore >= 2.5) {
  //   boxColor = "#FFA500"; // High Risk
  // } else {
  //   boxColor = "#FF0000"; // Severe Risk
  // }

  const maxScorePerRow = 5;
  const totalPossibleScore = scores?.length * maxScorePerRow;
  const percentageCumulative = cumulativeScore;

  const percentage =
    reportType === "HSE" ? scorePercent :
      totalPossibleScore > 0
        ? (percentageCumulative / totalPossibleScore) * 100
        : 0;

  // Determine box color based on percentage
  let boxColor = "#FFD700"; // default (yellow)

  if (percentage >= 85) {
    boxColor = "#00A651"; // Low Risk
  } else if (percentage >= 65) {
    boxColor = "#FFFF00"; // Medium Risk
  } else if (percentage >= 25) {
    boxColor = "#FFA500"; // High Risk
  } else {
    boxColor = "#FF0000"; // Severe Risk
  }

  // Risk label shown under the percentage in the Overall Assessment Indicator
  // (mirrors ExportSavedReportPDF currentRisk?.risk)
  const currentRisk =
    percentage >= 85 ? riskLevels[0]
      : percentage >= 65 ? riskLevels[1]
        : percentage >= 25 ? riskLevels[2]
          : riskLevels[3];

  // "3. Overall Risk Assessment Indicator" label, derived from the same value as
  // the displayed percentage so it stays consistent with the score and matches
  // ExportSavedReportPDF's indicatorRisk.
  const indicatorScore = Math.floor((cumulativeScore / 25) * 100);
  const indicatorRisk =
    indicatorScore >= 85 ? riskLevels[0]
      : indicatorScore >= 65 ? riskLevels[1]
        : indicatorScore >= 25 ? riskLevels[2]
          : riskLevels[3];
  let date = startDate.getTime() === endDate.getTime()
    ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
    : `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`

  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const formatDate = (date) => {
    return `${date.getDate().toString().padStart(2, "0")} ${date.toLocaleString("en-US", { month: "short" })} ${date.getFullYear()}`;
  };
  const dateText =
    startDate.getTime() === endDate.getTime()
      ? formatDate(startDate)
      : `${formatDate(startDate)} to ${formatDate(endDate)}`;


  let year = startDate.getTime() === endDate.getTime()
    ? startDate.getFullYear()
    : `${startDate.getFullYear()} to ${endDate.getFullYear()}`;

  let service = reportType === "HSE" ? "HSE Audit" : "Electrical Audit"


  const GenerateCoverpage = async (setCoverImage, client, service, location, date, reportType) => {
    const container = document.createElement("div");
    container.style.width = "850px"; // A4 width in pixels
    container.style.height = "1123px"; // A4 height in pixels
    container.style.position = "absolute";
    container.style.background = "#fff";

    // Insert cover + text overlays
    container.innerHTML = `
    <div style="width:100%; height:100%; position:relative;">
      <img src="${reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}" 
           style="width:100%; height:100%; object-fit:cover;" />

      <!-- Dynamic text placeholders -->
      <div style="position:absolute; top:591px; left:140px; font-size:${client.length > 30 ? "16px" : "20px"}; font-family:Montserrat; color:#307268;">
        ${client || ""}
      </div>
      <div style="position:absolute; top:637px; left:170px; font-size:${location.length > 30 ? "16px" : "20px"}; font-family:Montserrat; color:#307268;">
      ${location || ""}
      </div>
      <div style="position:absolute; top:683px; left:150px; font-size:20px; font-family:Montserrat; color:#307268;">
      ${service || ""}
      </div>
      <div style="position:absolute; top:730px; left:122px; font-size:18px; font-family:Montserrat; color:#307268;">
        ${date || ""}
      </div>
    </div>
  `;

    document.body.appendChild(container);

    // Convert to canvas
    const canvas = await html2canvas(container);
    const base64Image = canvas.toDataURL("image/png");

    document.body.removeChild(container); // cleanup

    setCoverImage(base64Image);
  };

  const GenerateCoverpageForHSE = async (setCoverImageHSE, client, service, location, date, reportType) => {
    const container = document.createElement("div");
    container.style.width = "850px"; // A4 width in pixels
    container.style.height = "1123px"; // A4 height in pixels
    container.style.position = "absolute";
    container.style.background = "#fff";

    // Insert cover + text overlays
    container.innerHTML = `
    <div style="width:100%; height:100%; position:relative;">
      <img src="${reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}" 
           style="width:100%; height:100%; object-fit:cover;" />

      <!-- Dynamic text placeholders -->
      <div style="position:absolute; top:${client.length > 30 ? "595px" : "591px"}; left:${client.length > 30 ? "125px" : "140px"}; font-size:${client.length > 30 ? "16px" : "20px"}; font-family:Montserrat; color:#307268;">
        ${client || ""}
      </div>
       <div style="position:absolute; top:${location.length > 30 ? "640px" : "637px"}; left:${location.length > 30 ? "155px" : "170px"}; font-size:${location.length > 30 ? "16px" : "20px"}; font-family:Montserrat; color:#307268;">
        ${location || ""}
      </div>
      <div style="position:absolute; top:683px; left:150px; font-size:20px; font-family:Montserrat; color:#307268;">
        ${service || ""}
      </div>
     
      <div style="position:absolute; top:730px; left:122px; font-size:18px; font-family:Montserrat; color:#307268;">
        ${date || ""}
      </div>
    </div>
  `;

    document.body.appendChild(container);

    // Convert to canvas
    const canvas = await html2canvas(container);
    const base64Image = canvas.toDataURL("image/png");

    document.body.removeChild(container); // cleanup

    setCoverImageHSE(base64Image);
  };


  useEffect(() => {
    fetchImage();
    fetchBase64Images();
    let tmpSiteLabel = selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite.label;
    GenerateCoverpage(setCoverImage, selectedOrganization.label, service, tmpSiteLabel, date, reportType, year)
    GenerateCoverpageForHSE(setCoverImageHSE, selectedOrganization.label, service, tmpSiteLabel, date, reportType, year)

    // GenerateCoverpage(setCoverImage, reportType);
  }, []);

  const fetchImage = async () => {
    // const base64Image = await imageToBase64(reportType==="HSE"?HSE_Cover:Electrical_Cover);
    // setCoverImage(base64Image);
    const base64logo = await imageToBase64(logo)
    setBase64Logo(base64logo)
  };

  const fetchBase64Images = async () => {
    try {
      setLoading(true);
      const selectedObsCopyWithImages = await Promise.all(selectedObservations.map(async observation => {
        let images = [];
        if (observation.imageUrls && observation.imageUrls.length > 0) {
          images = await Promise.all(observation.imageUrls.map(async imageUrl => {
            // let imgUrl = Object.values(imageUrl)[0];
            try {
              const response = await axios.post(`${config.PATH}/api/image-to-base64`,{imageUrl:imageUrl});
              return response.data.base64Image; // Assuming the backend returns base64-encoded images
            } catch (error) {
              console.error(`Error fetching image from ${imageUrl}:`, error.message);
              return null;
            }
          }));
        }
        return { ...observation, imageUrls: images };
      }));
      setSelectedObsCopy(selectedObsCopyWithImages);
    } catch (error) {
      console.error("Error fetching base64 images:", error.message);
    } finally {
      setLoading(false);
    }
  };

  function convertCmToTwip(cm) {
    return cm * 38.00;
  }

  const createWordDocument = () => {
    try {

      //Working paragraph of backgroundbrief
      const backgroundBriefParagraph3 = convertHtmlToParagraphs(backgroundBrief);
      const contentParagraph3 = convertHtmlToParagraphs(contents);
      const executiveSummaryParagraph3 = convertHtmlToParagraphs(exeSummary);
      const executiveSummaryFindingsParagraph3 = convertHtmlToParagraphs(exeSummaryFindigs);
      const executiveSummaryKeyObservationsParagraph3 = convertHtmlToParagraphs(exeSummaryKeyObservations);
      const theWayForwardParagraph3 = convertHtmlToParagraphs(theWayForward);
      const conclusionParagraph3 = convertHtmlToParagraphs(conclusion);
      const introductionParagraph3 = convertHtmlToParagraphs(introduction);
      const bestPracticeParagraph3 = convertHtmlToParagraphs(bestPractice);
      const HseimprovementOpportunity = convertHtmlToParagraphs(improvementOpportunityAreas);
      const improvementOpportunityParagraph3 = convertHtmlToParagraphsForImprovementOpportunityAreas(improvementOpportunityAreas);
      const overallAssessmentParagraph3 = convertHtmlToParagraphs(overallAssessmentIndicator);
      const classificationOfAuditObservationsParagraph3 = convertHtmlToParagraphs(classificationOfAuditObservations)
      const auditScoreAnalysisParagraph3 = convertHtmlToParagraphs(auditScoreAnalysis)
      // console.log("data before",overallAssessmentEditor)
      // console.log("odata",overallAssessmentParagraph3)


      const otherDetailsParagraphs = otherDetails && otherDetails
        .split("\n")
        .map((text) => new Paragraph({ children: [new TextRun(text)] }));
      //       const disclaimer = `This report is based on information provided to us and our own observations during the audit. We have conducted
      // the audit in accordance with generally accepted auditing standards. This report is provided for informational purposes only and
      // should not be relied upon as a complete representation of the Safety of the organization's information systems. By using this
      // information, you agree that Momentum shall be held harmless in any event.`
      const disclaimer = `This report is based on information provided and observations made during the audit. It is for informational purposes only and does not guarantee complete compliance or absolute safety. The organization is responsible for implementing corrective measures suggested in the audit report. By using this information, you agree that Momentum shall not be held responsible for any untoward events.`
      const doc = new Document({
        styles: {
          default: {
            document: {
              run: {
                font: "Montserrat",
              },
            },
          },
        },
        sections: [
          // for electrical coverpage
          ...(reportType != "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // A4 Landscape width (29.7 cm)
                  //   height: 11906,  // A4 Landscape height (21 cm)
                  // },
                  pageNumbers: {
                    start: 0
                  },
                  margin: {
                    top: 0, right: 0, left: 0, bottom: 0
                  }
                },
              },

              children: [
                coverImage &&
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: coverImage,
                      transformation: {
                        width: convertCmToTwip(21),  // A4 width in cm
                        height: convertCmToTwip(29.7),
                      },
                      floating: {
                        horizontalPosition: {
                          relative: "page",
                          offset: 0,
                        },
                        verticalPosition: {
                          relative: "page",
                          offset: 0,
                        },
                        // behindDocument: true, // Image behind text
                      },
                    }),
                  ],
                }),
              ],
            },

          ] : []

          ),


          //for hse coverpage
          ...(reportType === "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // A4 Landscape width (29.7 cm)
                  //   height: 11906,  // A4 Landscape height (21 cm)
                  // },
                  pageNumbers: {
                    start: 0
                  },
                  margin: {
                    top: 0, right: 0, left: 0, bottom: 0
                  }
                },
              },

              children: [
                ...(coverImageHSE ? [
                  new Paragraph({
                    children: [
                      new ImageRun({
                        data: coverImageHSE,
                        transformation: {
                          width: convertCmToTwip(21),  // A4 width in cm
                          height: convertCmToTwip(29.7),
                        },
                        floating: {
                          horizontalPosition: {
                            relative: "page",
                            offset: 0,
                          },
                          verticalPosition: {
                            relative: "page",
                            offset: 0,
                          },
                          // behindDocument: true, // Image behind text
                        },
                      }),
                    ],
                  }),
                ] : []),
              ],
            },
          ] : []

          ),

          // backgroundBrief for electrical report
          ...(reportType !== "HSE"
            ? [
              {
                properties: {
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838,   // 29.7 cm
                    //   height: 11906,  // 21 cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500
                    },
                    pageNumbers: {
                      start: 1,
                      formatType: NumberFormat.DECIMAL,
                    },
                  }
                },
                footers: {
                  default: new Footer({
                    children: [
                      new Paragraph({
                        alignment: AlignmentType.RIGHT,
                        indent: {
                          right: 1000,
                        },
                        children: [
                          new TextRun({
                            children: [

                              PageNumber.CURRENT,
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                },

                children: [
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: {
                              size: 100,
                              type: WidthType.PERCENTAGE,
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: ``,
                                    size: 30,
                                    font: "Montserrat",
                                    color: "#ffffff",
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: {
                                      width: 120,
                                      height: 40,
                                    },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                        tableHeader: true,

                      }),
                    ],
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE,
                    },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1,
                  }),
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: {
                              left: 300,   // ~1 inch left gap
                              right: 300,  // ~1 inch right gap
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Heading
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: "DOCUMENT HISTORY",
                                    font: "Montserrat",
                                    color: "#307268",
                                    size: 25,
                                    bold: true,
                                  }),
                                ],
                                break: 1,
                              }),

                              new Paragraph({ break: 1 }), // line break after heading

                              // Table inside the same margin box


                              new Table({
                                width: { size: "100%", type: WidthType.PERCENTAGE },
                                rows: [
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        shading: { fill: "#efc71d" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: "PARTICULARS",
                                                bold: true,
                                              }),
                                            ],
                                            // shading: { fill: "#efc71d" },
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        shading: { fill: "#efc71d" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: "DETAILS",
                                                bold: true,
                                              }),
                                            ],
                                            // shading: { fill: "#efc71d" },
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                    ],
                                  }),
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: "Date of Visit",
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                // text:
                                                //   startDate.getTime() === endDate.getTime()
                                                //     ? `${startDate.getDate()}-${(startDate.getMonth() + 1)
                                                //         .toString()
                                                //         .padStart(2, "0")}-${startDate.getFullYear()}`
                                                //     : `${startDate.getDate()}-${(startDate.getMonth() + 1)
                                                //         .toString()
                                                //         .padStart(2, "0")}-${startDate.getFullYear()} to ${endDate.getDate()}-${(
                                                //         endDate.getMonth() + 1
                                                //       )
                                                //         .toString()
                                                //         .padStart(2, "0")}-${endDate.getFullYear()}`,
                                                // text: `${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString("en-US", { month: "short" })} ${startDate.getFullYear()}`,
                                                text: dateText
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                    ],
                                  }),
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: "Document Prepared By",
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: name,
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                    ],
                                  }),
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: "Date of Document Submission",
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                      new TableCell({
                                        margins: { top: 50, bottom: 50, },
                                        children: [
                                          new Paragraph({
                                            children: [
                                              new TextRun({
                                                font: "Montserrat",
                                                text: selectedDateTime.split("-").reverse().join("-"),
                                              }),
                                            ],
                                          }),
                                        ],
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                      }),
                                    ],
                                  }),
                                ],
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),





                              //             new Table({
                              //   width: { size: 100, type: WidthType.PERCENTAGE },
                              //   rows: [
                              //     new TableRow({
                              //       children: [
                              //         new TableCell({
                              //           shading: { fill: "#efc71d" },
                              //           height: { value: 400, rule: HeightRule.EXACT }, 
                              //           margins: { top: 80, bottom: 80 },
                              //           children: [
                              //             new Paragraph({
                              //               alignment: AlignmentType.CENTER,
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   text: "PARTICULARS",
                              //                   bold: true,
                              //                   size: 22, 
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),

                              //         new TableCell({
                              //           shading: { fill: "#efc71d" },
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 80, bottom: 80 },
                              //           children: [
                              //             new Paragraph({
                              //               alignment: AlignmentType.CENTER,
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   text: "DETAILS",
                              //                   bold: true,
                              //                   size: 22,
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),
                              //       ],
                              //     }),
                              //     new TableRow({
                              //       children: [
                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: "Date of Visit",
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),

                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: `${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString(
                              //                     "en-US",
                              //                     { month: "short" }
                              //                   )} ${startDate.getFullYear()}`,
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),
                              //       ],
                              //     }),

                              //     new TableRow({
                              //       children: [
                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: "Document Prepared By",
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),

                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: name,
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),
                              //       ],
                              //     }),

                              //     new TableRow({
                              //       children: [
                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: "Date of Document Submission",
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),

                              //         new TableCell({
                              //           height: { value: 400, rule: HeightRule.EXACT },
                              //           margins: { top: 120, bottom: 120 },
                              //           children: [
                              //             new Paragraph({
                              //               children: [
                              //                 new TextRun({
                              //                   font: "Montserrat",
                              //                   size: 22,
                              //                   text: selectedDateTime.split("-").reverse().join("-"),
                              //                 }),
                              //               ],
                              //             }),
                              //           ],
                              //           borders: {
                              //             top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //             right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              //           },
                              //         }),
                              //       ],
                              //     }),
                              //   ],

                              //   /* Remove outer borders */
                              //   borders: {
                              //     top: { style: BorderStyle.NONE },
                              //     bottom: { style: BorderStyle.NONE },
                              //     left: { style: BorderStyle.NONE },
                              //     right: { style: BorderStyle.NONE },
                              //     insideHorizontal: { style: BorderStyle.NONE },
                              //     insideVertical: { style: BorderStyle.NONE },
                              //   },
                              // })

                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),

                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1,
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1,
                  }),
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "BACKGROUND - PROJECT BRIEF",
                        font: "Montserrat",
                        color: "#307268",
                        size: 25,
                        bold: true
                      }),
                    ],
                    break: 1,
                    indent: {
                      left: 300,
                      right: 1000
                    }
                  }),
                  new Paragraph({ break: 1 }),
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: {
                              left: 300,  // 1 inch left gap
                              right: 300, // 1 inch right gap
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Inner table with yellow background
                              new Table({
                                rows: [
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        shading: {
                                          type: "clear",
                                          color: "auto",
                                          // fill: "fff8dc", 
                                        },
                                        margins: {
                                          top: 200,    // padding inside yellow box
                                          bottom: 200,
                                          // left: 200,
                                          // right: 200,
                                        },
                                        borders: {
                                          top: { style: BorderStyle.NONE },
                                          bottom: { style: BorderStyle.NONE },
                                          left: { style: BorderStyle.NONE },
                                          right: { style: BorderStyle.NONE },
                                        },
                                        children: [
                                          ...backgroundBriefParagraph3,
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),


                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: {
                              left: 300,   // 1 inch left gap
                              right: 300,  // 1 inch right gap
                              // top:6000,
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: "Disclaimer:",
                                    font: "Montserrat",
                                    color: "#307268",
                                    bold: true,
                                    size: 18,
                                    italics: true,
                                  }),
                                ],
                                break: 1,
                              }),
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: disclaimer, // your dynamic disclaimer text
                                    font: "Montserrat",
                                    size: 18,
                                    italics: true,
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),


                ],
              },
            ]
            : []),
          // understanding reports for HSE
          ...(reportType == "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              footers: {
                default: new Footer({
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.RIGHT,
                      indent: {
                        right: 1000,
                      },
                      children: [
                        new TextRun({
                          children: [

                            PageNumber.CURRENT,
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              },

              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          // shading: {
                          //   fill: "#02075d",
                          // },
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Understanding The Report",
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                  bold: true,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break
                            ...contentParagraph3,        // your content with same left/right spacing
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Disclaimer:",
                                  font: "Montserrat",
                                  color: "#307268",
                                  bold: true,
                                  size: 18,
                                  italics: true,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: disclaimer, // your dynamic disclaimer text
                                  font: "Montserrat",
                                  size: 18,
                                  italics: true,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

              ],
            },] : []),


          // audit description for HSE
          // ...(reportType === "HSE"
          //   ? [
          //       {
          //         properties: {
          //           page: {
          //             orientation: PageOrientation.PORTRAIT,
          //             // size: {
          //             //   width: 16838, // A4 landscape (29.7cm)
          //             //   height: 11906, // 21cm
          //             // },
          //             margin: {
          //               top: 500,
          //               left: 500,
          //               right: 500,
          //             },
          //           },
          //         },
          //         children: [
          //           // ===== HEADER ROW (LOGO) =====
          //           new Table({
          //             rows: [
          //               new TableRow({
          //                 children: [
          //                   new TableCell({
          //                     width: { size: 100, type: WidthType.PERCENTAGE },
          //                     borders: {
          //                       top: { style: BorderStyle.NONE },
          //                       bottom: { style: BorderStyle.NONE },
          //                       left: { style: BorderStyle.NONE },
          //                       right: { style: BorderStyle.NONE },
          //                     },
          //                     children: [new Paragraph({ children: [new TextRun("")] })],
          //                   }),
          //                   new TableCell({
          //                     borders: {
          //                       top: { style: BorderStyle.NONE },
          //                       bottom: { style: BorderStyle.NONE },
          //                       left: { style: BorderStyle.NONE },
          //                       right: { style: BorderStyle.NONE },
          //                     },
          //                     children: [
          //                       new Paragraph({
          //                         children: [
          //                           new ImageRun({
          //                             data: base64logo,
          //                             transformation: { width: 120, height: 40 },
          //                           }),
          //                         ],
          //                       }),
          //                     ],
          //                     verticalAlign: "center",
          //                   }),
          //                 ],
          //               }),
          //             ],
          //             width: { size: 100, type: WidthType.PERCENTAGE },
          //             borders: {
          //               top: { style: BorderStyle.NONE },
          //               bottom: { style: BorderStyle.NONE },
          //               left: { style: BorderStyle.NONE },
          //               right: { style: BorderStyle.NONE },
          //               insideHorizontal: { style: BorderStyle.NONE },
          //               insideVertical: { style: BorderStyle.NONE },
          //             },
          //           }),

          //           new Paragraph({ children: [new TextRun("")], break: 1 }),

          //           // ===== OUTER WRAPPER TABLE FOR LEFT SPACING =====
          //           new Table({
          //             rows: [
          //               new TableRow({
          //                 children: [
          //                   new TableCell({
          //                     width: { size: 100, type: WidthType.PERCENTAGE },
          //                     margins: { left: 300,    right: 800 },
          //                     borders: {
          //                       top: { style: BorderStyle.NONE },
          //                       bottom: { style: BorderStyle.NONE },
          //                       left: { style: BorderStyle.NONE },
          //                       right: { style: BorderStyle.NONE },
          //                     },
          //                     children: [
          //                       // ===== HEADING =====
          //                       new Paragraph({
          //                         children: [
          //                           new TextRun({
          //                             text: "Audit Description ",
          //                             bold: true,
          //                             font: "Montserrat",
          //                             color: "#307268",
          //                             size: 26,
          //                           }),
          //                           new TextRun({
          //                             text: "(It changes based on the audit)",
          //                             font: "Montserrat",
          //                             color: "#555555",
          //                             size: 22,
          //                           }),
          //                         ],
          //                         spacing: { after: 200 },
          //                       }),

          //                       // ===== INNER TABLE (YELLOW LEFT COLUMN) =====
          //                       new Table({
          //                         width: { size: 100, type: WidthType.PERCENTAGE },
          //                         borders: {
          //                           top: { style: BorderStyle.SINGLE, size: 1 },
          //                           bottom: { style: BorderStyle.SINGLE, size: 1 },
          //                           left: { style: BorderStyle.SINGLE, size: 1 },
          //                           right: { style: BorderStyle.SINGLE, size: 1 },
          //                           insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
          //                           insideVertical: { style: BorderStyle.SINGLE, size: 1 },
          //                         },
          //                         rows: [
          //                           ["Client", selectedOrganization?.label || "N/A"],
          //                           ["Location", selectedSite?.label || "N/A"],
          //                           [
          //                             "Date of Site Visit",
          //                             startDate
          //                               ? new Date(startDate).toLocaleDateString("en-GB")
          //                               : "N/A",
          //                           ],
          //                           ["Study", "HSE Audit Report"],
          //                           [
          //                             "Time of Audit (From & To)",
          //                             timeFrom && timeTo
          //                               ? `${timeFrom.slice(0, 5)} to ${timeTo.slice(
          //                                   0,
          //                                   5
          //                                 )}`
          //                               : "N/A",
          //                           ],
          //                           [
          //                             "Brief Property Description",
          //                             briefPropertyDescription || "N/A",
          //                           ],
          //                           ["Number of floors", numOfFloors || "N/A"],
          //                           [
          //                             "Average Staff Footfall",
          //                             avgStaffFootfall || "N/A",
          //                           ],
          //                           [
          //                             "No Objection Certificate:",
          //                             noObjectionCertificate || "N/A",
          //                           ],
          //                           [
          //                             "National Building Code Category",
          //                             nationalBuildingCodeCategory || "N/A",
          //                           ],
          //                           [
          //                             "Coordinating Person – Client Side",
          //                             coordinationgPersonClientside || "N/A",
          //                           ],
          //                           ["Report Prepared By", reportPreparedBy || "N/A"],
          //                           ["Report Reviewed By", reportReviewedBy || "N/A"],
          //                           [
          //                             "Date of Submission of Report",
          //                             endDate
          //                               ? new Date(endDate).toLocaleDateString("en-GB")
          //                               : "N/A",
          //                           ],
          //                         ].map(
          //                           ([label, value]) =>
          //                             new TableRow({
          //                               children: [
          //                                 new TableCell({
          //                                   width: {
          //                                     size: 40,
          //                                     type: WidthType.PERCENTAGE,
          //                                   },
          //                                   shading: { fill: "FFF7D7" }, // light yellow
          //                                   margins: {
          //                                     top: 100,
          //                                     bottom: 100,
          //                                     left: 150,
          //                                     right: 150,
          //                                   },
          //                                   children: [
          //                                     new Paragraph({
          //                                       children: [
          //                                         new TextRun({
          //                                           text: label,
          //                                           bold: true,
          //                                           font: "Montserrat",
          //                                           size: 22,
          //                                         }),
          //                                       ],
          //                                     }),
          //                                   ],
          //                                 }),
          //                                 new TableCell({
          //                                   width: {
          //                                     size: 60,
          //                                     type: WidthType.PERCENTAGE,
          //                                   },
          //                                   margins: {
          //                                     top: 100,
          //                                     bottom: 100,
          //                                     left: 150,
          //                                     right: 150,
          //                                   },
          //                                   children: [
          //                                     new Paragraph({
          //                                       children: [
          //                                         new TextRun({
          //                                           text: value,
          //                                           font: "Montserrat",
          //                                           size: 22,
          //                                         }),
          //                                       ],
          //                                     }),
          //                                   ],
          //                                 }),
          //                               ],
          //                             })
          //                         ),
          //                       }),
          //                     ],
          //                   }),
          //                 ],
          //               }),
          //             ],
          //             width: { size: 100, type: WidthType.PERCENTAGE },
          //             borders: {
          //               top: { style: BorderStyle.NONE },
          //               bottom: { style: BorderStyle.NONE },
          //               left: { style: BorderStyle.NONE },
          //               right: { style: BorderStyle.NONE },
          //               insideHorizontal: { style: BorderStyle.NONE },
          //               insideVertical: { style: BorderStyle.NONE },
          //             },
          //           }),
          //         ],
          //       },
          //     ]
          //   : []),
          ...(reportType === "HSE"
            ? [
              {
                properties: {
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838, // A4 landscape (29.7cm)
                    //   height: 11906, // 21cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                    },
                  },
                },
                children: [
                  // ===== HEADER ROW (LOGO) =====
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [new Paragraph({ children: [new TextRun("")] })],
                          }),
                          new TableCell({
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: { width: 120, height: 40 },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),

                  new Paragraph({ children: [new TextRun("")], break: 1 }),

                  // ===== OUTER WRAPPER TABLE FOR LEFT SPACING =====
                  // ===== OUTER WRAPPER WITH HEADING ABOVE TABLE (Portrait A4 Safe) =====
                  new Table({
                    layout: TableLayoutType.FIXED, // keep everything absolute, not relative
                    width: { size: 10900, type: WidthType.DXA }, // fits within portrait page after margins
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                    rows: [
                      // ===== HEADING ROW =====
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 10900, type: WidthType.DXA },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            margins: {
                              left: 100,   // 1 inch left gap
                              right: 300,  // 1 inch right gap
                            },
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.LEFT,
                                spacing: { after: 200 },
                                children: [
                                  new TextRun({
                                    text: "Audit Description ",
                                    bold: true,
                                    font: "Montserrat",
                                    color: "#307268",
                                    size: 28,
                                  }),
                                  new TextRun({
                                    text: "(It changes based on the audit)",
                                    font: "Montserrat",
                                    color: "#555555",
                                    size: 22,
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),

                      // ===== TABLE ROW CONTAINING THE INNER FIXED TWO-COLUMN TABLE =====
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 10900, type: WidthType.DXA },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // ===== INNER FIXED TWO-COLUMN TABLE =====
                              new Table({
                                layout: TableLayoutType.FIXED, // disables Word auto-fit
                                width: { size: 10900, type: WidthType.DXA }, // fits inside portrait printable width
                                borders: {
                                  top: { style: BorderStyle.SINGLE, size: 1 },
                                  bottom: { style: BorderStyle.SINGLE, size: 1 },
                                  left: { style: BorderStyle.SINGLE, size: 1 },
                                  right: { style: BorderStyle.SINGLE, size: 1 },
                                  insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
                                  insideVertical: { style: BorderStyle.SINGLE, size: 1 },
                                },
                                rows: [
                                  // === Optional Header Row ===
                                  // new TableRow({
                                  //   children: [
                                  //     new TableCell({
                                  //       shading: { fill: "#307268" },
                                  //       width: { size: 3500, type: WidthType.DXA },
                                  //       verticalAlign: VerticalAlign.CENTER,
                                  //       children: [
                                  //         new Paragraph({
                                  //           alignment: AlignmentType.CENTER,
                                  //           children: [
                                  //             new TextRun({
                                  //               text: "Description",
                                  //               bold: true,
                                  //               color: "#FFFFFF",
                                  //               size: 20,
                                  //               font: "Montserrat",
                                  //             }),
                                  //           ],
                                  //         }),
                                  //       ],
                                  //     }),
                                  //     new TableCell({
                                  //       shading: { fill: "#307268" },
                                  //       width: { size: 7400, type: WidthType.DXA },
                                  //       verticalAlign: VerticalAlign.CENTER,
                                  //       children: [
                                  //         new Paragraph({
                                  //           alignment: AlignmentType.CENTER,
                                  //           children: [
                                  //             new TextRun({
                                  //               text: "Details",
                                  //               bold: true,
                                  //               color: "#FFFFFF",
                                  //               size: 20,
                                  //               font: "Montserrat",
                                  //             }),
                                  //           ],
                                  //         }),
                                  //       ],
                                  //     }),
                                  //   ],
                                  // }),

                                  // === Body Rows ===
                                  ...[
                                    ["Client", selectedOrganization?.label || "N/A"],
                                    ["Location", selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label || "N/A"],
                                    [
                                      "Date of Site Visit",
                                      startDate ? `${String(new Date(startDate).getDate()).padStart(2, '0')}-${String(new Date(startDate).getMonth() + 1).padStart(2, '0')}-${new Date(startDate).getFullYear()}` : "N/A",
                                    ],
                                    ["Study", "HSE Audit Report"],

                                    ...((timeFrom || timeTo) ?
                                      [[
                                        "Time of Audit (From & To)",
                                        (timeFrom && timeTo
                                          ? `${timeFrom.slice(0, 5)} to ${timeTo.slice(0, 5)}`
                                          : "N/A") + (" (Date wise breakup)"),
                                      ]] : []),
                                    ...(briefPropertyDescription ?
                                      [["Brief Property Description", briefPropertyDescription || "N/A"]]
                                      : []),

                                    ...(numOfFloors ?
                                      [["Number of floors", numOfFloors || "N/A"]] : []),

                                    ...(avgStaffFootfall ?
                                      [["Average Staff Footfall", avgStaffFootfall || "N/A"]] : []),

                                    ...(noObjectionCertificate ?
                                      [["No Objection Certificate:", noObjectionCertificate || "N/A"]] : []),

                                    ...(nationalBuildingCodeCategory ?
                                      [["National Building Code Category", nationalBuildingCodeCategory || "N/A"]] : []),

                                    ...(coordinationgPersonClientside ?
                                      [["Coordinating Person – Client Side", coordinationgPersonClientside || "N/A"]] : []),

                                    ...(reportPreparedBy ?
                                      [["Report Prepared By", reportPreparedBy || "N/A"]] : []),

                                    ...(reportReviewedBy ?
                                      [["Report Reviewed By", reportReviewedBy || "N/A"]] : []),
                                    ...(buildingName ?
                                      [["Building Name", buildingName || "N/A"]] : []),

                                    [
                                      "Date of Submission of Report",
                                      endDate ? `${String(new Date(endDate).getDate()).padStart(2, '0')}-${String(new Date(endDate).getMonth() + 1).padStart(2, '0')}-${new Date(endDate).getFullYear()}` : "N/A",
                                    ],
                                  ].map(
                                    ([label, value]) =>
                                      new TableRow({
                                        children: [
                                          // LEFT COLUMN (Label)
                                          new TableCell({
                                            width: { size: 3500, type: WidthType.DXA }, // fixed width
                                            shading: { fill: "#FFF7D7" },
                                            verticalAlign: VerticalAlign.CENTER,
                                            borders: {
                                              top: { style: BorderStyle.SINGLE },
                                              bottom: { style: BorderStyle.SINGLE },
                                              left: { style: BorderStyle.SINGLE },
                                              right: { style: BorderStyle.SINGLE },
                                            },
                                            children: [
                                              new Paragraph({
                                                alignment: AlignmentType.LEFT,
                                                indent: { left: 100 },
                                                children: [
                                                  new TextRun({
                                                    text: label,
                                                    bold: true,
                                                    font: "Montserrat",
                                                    size: 22,
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                          // RIGHT COLUMN (Value)
                                          new TableCell({
                                            width: { size: 7400, type: WidthType.DXA },
                                            verticalAlign: VerticalAlign.CENTER,
                                            borders: {
                                              top: { style: BorderStyle.SINGLE },
                                              bottom: { style: BorderStyle.SINGLE },
                                              left: { style: BorderStyle.SINGLE },
                                              right: { style: BorderStyle.SINGLE },
                                            },
                                            children: [
                                              new Paragraph({
                                                alignment: AlignmentType.LEFT,
                                                spacing: { line: 276 },
                                                indent: { left: 100 },
                                                children: [
                                                  new TextRun({
                                                    text: value,
                                                    font: "Montserrat",
                                                    size: 22,
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                        ],
                                      })
                                  ),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              },
            ]
            : []),



          // classification of audit observations of HSE
          ...(reportType === "HSE" ? [
            {

              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,     // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Classification of Audit Observations",
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                  bold: true,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break  
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...classificationOfAuditObservationsParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),


              ],
            },
          ] : []),


          // Audit Objective of HSE
          ...(reportType === "HSE" ? [
            {

              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Audit Objective ",
                                  bold: true,
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                }),
                                new TextRun({
                                  text: "(It changes based on the audit)",
                                  font: "Montserrat",
                                  color: "#555555",
                                  size: 22,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break  
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...backgroundBriefParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),


              ],
            },
          ] : []),

          // executive summary for HSE
          ...(reportType === "HSE" ? [
            {

              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Executive Summary ",
                                  bold: true,
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                }),
                                new TextRun({
                                  text: "(It changes based on the audit)",
                                  font: "Montserrat",
                                  color: "#555555",
                                  size: 22,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break  
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                                // executive summary findings section
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      width: { size: 100, type: WidthType.PERCENTAGE },
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                      },
                                      margins: {
                                        left: 100,   // 1 inch left gap
                                        right: 100,  // 1 inch right gap
                                        top: 150, 
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        new Paragraph({
                                          children: [
                                            new TextRun({
                                              text: "Findings",
                                              bold: true,
                                              font: "Montserrat",
                                              color: "#307268",
                                              size: 28,
                                            }),
                                            new TextRun({
                                              text: "",
                                              font: "Montserrat",
                                              color: "#555555",
                                              size: 22,
                                            }),
                                          ],
                                          break: 1,
                                        }),
                                        new Paragraph({ break: 1 }), // line break  
                                      ],
                                    }),
                                  ],
                                }),
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryFindingsParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      width: { size: 100, type: WidthType.PERCENTAGE },
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                      },
                                      margins: {
                                        left: 100,   // 1 inch left gap
                                        right: 100,  // 1 inch right gap
                                        top: 150, 
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        new Paragraph({
                                          children: [
                                            new TextRun({
                                              text: "Key Observations ",
                                              bold: true,
                                              font: "Montserrat",
                                              color: "#307268",
                                              size: 28,
                                            }),
                                            new TextRun({
                                              text: "",
                                              font: "Montserrat",
                                              color: "#555555",
                                              size: 22,
                                            }),
                                          ],
                                          break: 1,
                                        }),
                                        new Paragraph({ break: 1 }), // line break  
                                      ],
                                    }),
                                  ],
                                }),
                                // Executive summary key observation section
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryKeyObservationsParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),


              ],
            },
          ] : []),
          //Audit score analysis of HSE
          ...(reportType === "HSE" ? [
            {

              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Audit Score Analysis ",
                                  bold: true,
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                }),
                                new TextRun({
                                  text: "(It changes based on the audit)",
                                  font: "Montserrat",
                                  color: "#555555",
                                  size: 22,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break  
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...auditScoreAnalysisParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),


              ],
            },
          ] : []),

          // improvement opportunity areas for HSE
          ...(reportType == "HSE"
            ? [
              {

                properties: {
                  // type: SectionType.CONTINUOUS,
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838,   // 29.7 cm
                    //   height: 11906,  // 21 cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                      bottom: 500,
                    }
                  }
                },
                children: [
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: {
                              size: 100, // Adjust width as needed
                              type: WidthType.PERCENTAGE,
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: ``,
                                    size: 30,
                                    font: "Montserrat",
                                    color: "#ffffff", // Adjust text color for visibility
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: {
                                      width: 120,
                                      height: 40,
                                    },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                        tableHeader: true,
                      }),
                    ],
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE,
                    },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1
                  }),
                  // Heading
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            shading: {
                              type: "clear",
                              color: "auto",
                            },
                            margins: {
                              left: 300,  // 1 inch left gap
                              right: 300, // 1 inch right gap
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: "Improvement Opportunity Areas ",
                                    bold: true,
                                    font: "Montserrat",
                                    color: "#307268",
                                    size: 26,
                                  }),
                                  new TextRun({
                                    text: "(Deductibles - It changes based on the audit)",
                                    font: "Montserrat",
                                    color: "#555555",
                                    size: 20,
                                  }),
                                ],

                              }),
                              new Paragraph({ break: 1 }), // line break
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),

                  // Yellow Box with content
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: {
                              left: 300,  // spacing outside yellow
                              right: 300,
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Table({
                                rows: [
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        shading: {
                                          type: "clear",
                                          color: "auto",
                                          fill: "fff8dc", // Light cream-yellow
                                        },
                                        margins: {
                                          top: 200,    // padding inside yellow
                                          bottom: 200,
                                          left: 200,
                                          right: 200,
                                        },
                                        borders: {
                                          top: { style: BorderStyle.NONE },
                                          bottom: { style: BorderStyle.NONE },
                                          left: { style: BorderStyle.NONE },
                                          right: { style: BorderStyle.NONE },
                                        },
                                        children: [
                                          // ...improvementOpportunityParagraph3,
                                          ...HseimprovementOpportunity
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),


                ],
              },
            ]
            : []),
          // overall risk indicator for HSE (commented out)
          ...(reportType == "HSE"
            ? [
              {
                properties: {
                  //  type: SectionType.CONTINUOUS,
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838,   // 29.7 cm
                    //   height: 11906,  // 21 cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                      bottom: 500
                    }
                  }
                },
                children: [
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: {
                              size: 100, // Adjust width as needed
                              type: WidthType.PERCENTAGE,
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: ``,
                                    size: 30,
                                    font: "Montserrat",
                                    color: "#ffffff", // Adjust text color for visibility
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: {
                                      width: 120,
                                      height: 40,
                                    },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                        tableHeader: true,
                      }),
                    ],
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE,
                    },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1
                  }),
                  // Heading
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Overall Assessment Indicator",
                        font: "Montserrat",
                        color: "#307268",
                        size: 28,
                        bold: true,
                      }),
                    ],
                    spacing: {
                      after: 200, // space after paragraph
                    },
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                  }),


                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: { left: 300, right: 300 }, // spacing from page edges
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Inner table → Left-right percentage layout
                              new Table({
                                rows: [
                                  new TableRow({
                                    children: [
                                      // LEFT CELL → Fixed width score box (20%, matching the PDF flex 2:8 split)
                                      new TableCell({
                                        width: { size: 2040, type: WidthType.DXA },
                                        // shading: { fill: "FFD700" },
                                        shading: { fill: boxColor },
                                        // Top-anchored so the score/label sit at a consistent
                                        // position regardless of how much content the right cell
                                        // holds (matches the PDF export's top-aligned score box).
                                        // A large spacing.before was previously used to fake page-1
                                        // centering, but it jammed the score to the bottom of the
                                        // box whenever the assessment text was short.
                                        verticalAlign: VerticalAlign.TOP,
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            spacing: { before: 200 },
                                            children: [
                                              new TextRun({
                                                //  text: `${((cumulativeScore / 10) * 100).toFixed(2)}%`,
                                                color: "000000",
                                                text: `${scorePercent}%`,
                                                bold: true, size: 48
                                              }),
                                            ],
                                          }),
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            spacing: { before: 120 },
                                            children: [
                                              new TextRun({
                                                text: currentRisk?.risk || "",
                                                bold: true,
                                                size: 24,
                                                color: "000000",
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),

                                      // RIGHT CELL → Dynamic content (80%, matching the PDF flex 2:8 split)
                                      new TableCell({
                                        width: { size: 8160, type: WidthType.DXA },
                                        margins: { top: 200, bottom: 200, left: 300, right: 300 },
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                        children: [
                                          ...overallAssessmentParagraph3, // your content here
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                                // Fixed layout + explicit column widths so Word honors the
                                // 20/80 split instead of autofitting columns to content.
                                // Total fits the section content area (A4 portrait, 500 margins,
                                // less the outer cell's 300 margins) so it doesn't overflow.
                                width: { size: 10200, type: WidthType.DXA },
                                layout: TableLayoutType.FIXED,
                                columnWidths: [2040, 8160],
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),





                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Risk Legend",
                        font: "Montserrat",
                        color: "#307268",
                        size: 25,
                        bold: true,
                      }),
                    ],
                    spacing: {
                      after: 200, // space after paragraph
                    },
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                  }),
                  new Paragraph({
                    children: [
                      new TextRun({
                        // text: "The above image is for display purposes only",
                        font: "Montserrat",

                        size: 22,
                        bold: false,
                      }),
                    ],
                    spacing: {
                      after: 200, // space after paragraph
                    },
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                  }),
                  new Paragraph({ break: 1 }),
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: { left: 300, right: 800 }, // spacing from page edges
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Inner table → your actual risk levels table
                              new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE }, // full width inside the cell
                                borders: {
                                  top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  insideVertical: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                                rows: [



                                  //                 // Header Row
                                  //                 new TableRow({
                                  //                   children: ["Score Range", "Risk Level", "Interpretation"].map((text) =>
                                  //                     new TableCell({
                                  //                       shading: { fill: "#307260" },
                                  //                       children: [
                                  //                         new Paragraph({
                                  //                           alignment: AlignmentType.CENTER,
                                  //                           children: [
                                  //                             new TextRun({
                                  //                               text,
                                  //                               bold: true,
                                  //                               color: "#efc71d",
                                  //                               size: 24,
                                  //                             }),
                                  //                           ],
                                  //                         }),
                                  //                       ],
                                  //                     })
                                  //                   ),
                                  //                 }),
                                  //                 // Data Rows
                                  //                ...riskLevels.map((level) =>
                                  //   new TableRow({
                                  //     children: [
                                  //       // Score Range → colored
                                  //       new TableCell({
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             alignment: AlignmentType.CENTER,
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.range,
                                  //                 color: level.color, // use respective color
                                  //                 size: 20, // decrease by 1 from 25
                                  //                 bold:true

                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),

                                  //       new TableCell({
                                  //         shading: { fill: level.color },
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             alignment: AlignmentType.CENTER,
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.risk,
                                  //                 bold: false, // remove bold
                                  //                 size: 20, // decrease by 1
                                  //                 color: "#000000", // optional: black text on colored background
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),
                                  //       // Interpretation → normal text, smaller size
                                  //       new TableCell({
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.interpretation,
                                  //                 size: 20, // decrease by 1
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),
                                  //     ],
                                  //   })
                                  // ),

                                  new TableRow({
                                    height: { value: 500, rule: HeightRule.EXACT },
                                    children: [
                                      new TableCell({
                                        width: { size: 2000, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [new TextRun({ text: "Score Range", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),

                                      new TableCell({
                                        width: { size: 400, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [new TextRun({ text: "Risk Level", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),

                                      new TableCell({
                                        width: { size: 9600, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [new TextRun({ text: "Interpretation", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  ...riskLevels.map((level) =>
                                    new TableRow({
                                      height: { value: 600, rule: HeightRule.EXACT },
                                      children: [
                                        // Score Range
                                        new TableCell({
                                          width: { size: 3500, type: WidthType.DXA },
                                          verticalAlign: VerticalAlign.CENTER,
                                          children: [
                                            new Paragraph({
                                              alignment: AlignmentType.CENTER,
                                              children: [
                                                new TextRun({
                                                  text: level.range,
                                                  color: level.color,
                                                  size: 18,
                                                  bold: true,
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),

                                        // Risk Level
                                        new TableCell({
                                          width: { size: 3500, type: WidthType.DXA },
                                          shading: { fill: level.color },
                                          verticalAlign: VerticalAlign.CENTER,
                                          children: [
                                            new Paragraph({
                                              alignment: AlignmentType.CENTER,
                                              children: [
                                                new TextRun({
                                                  text: level.risk,
                                                  size: 18,
                                                  color: "#000000",
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),

                                        // Interpretation
                                        new TableCell({
                                          width: { size: 5000, type: WidthType.DXA },
                                          verticalAlign: VerticalAlign.CENTER,
                                          //  margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                          margins: { left: 200, right: 200 },
                                          children: [
                                            new Paragraph({
                                              // alignment: AlignmentType.CENTER, 
                                              children: [
                                                new TextRun({
                                                  text: level.interpretation,
                                                  size: 18,
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),
                                      ],
                                    })
                                  ),


                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),





                ],


              },
            ]
            : []),

          //Annexure details for HSE
          ...(reportType === "HSE"
            ? [
              {
                properties: {
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838, // A4 landscape (29.7cm)
                    //   height: 11906, // 21cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                    },
                  },
                },
                children: [

                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // new Paragraph({ children: [new TextRun("")] })
                            ],
                          }),
                          new TableCell({
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.RIGHT,
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: { width: 120, height: 40 },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),

                  //   new Paragraph({ children: [new TextRun("")], break: 1 }
                  // ),


                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Annexure - References & Standards",
                        bold: true,
                        font: "Montserrat",
                        color: "#307268",
                        size: 28,
                      }),
                    ],
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                    spacing: { after: 300 },
                  }),


                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: { left: 300, right: 1000 },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // ===== MAIN TABLE =====
                              new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                  top: { style: BorderStyle.SINGLE, size: 1 },
                                  bottom: { style: BorderStyle.SINGLE, size: 1 },
                                  left: { style: BorderStyle.SINGLE, size: 1 },
                                  right: { style: BorderStyle.SINGLE, size: 1 },
                                  insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
                                  insideVertical: { style: BorderStyle.SINGLE, size: 1 },
                                },
                                rows: [
                                  // ===== HEADER ROW =====
                                  new TableRow({
                                    height: { value: 500 }, // taller header
                                    children: [
                                      new TableCell({
                                        shading: { fill: "1E6255" }, // dark green
                                        verticalAlign: VerticalAlign.CENTER,
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [
                                              new TextRun({
                                                text: "Reference Type and Document / Standard",
                                                font: "Montserrat",
                                                color: "FFFFFF",
                                                size: 24,
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      new TableCell({
                                        shading: { fill: "1E6255" },
                                        verticalAlign: VerticalAlign.CENTER,
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [
                                              new TextRun({
                                                text: "Relevance to Audit Findings",
                                                font: "Montserrat",
                                                color: "FFFFFF",
                                                size: 24,
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),

                                  // ===== DYNAMIC ROWS =====
                                  // ...references.map((ref) =>
                                  //   ref.type === "heading"
                                  //     ? new TableRow({
                                  //         children: [
                                  //           new TableCell({
                                  //             columnSpan: 2,
                                  //             shading: { fill: "FFF7D7" }, // light yellow
                                  //             children: [
                                  //               new Paragraph({
                                  //                 children: [
                                  //                   new TextRun({
                                  //                     text: ref.section_name || "",
                                  //                     bold: true,
                                  //                     font: "Montserrat",
                                  //                     size: 20,
                                  //                   }),
                                  //                 ],
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       })
                                  //     : new TableRow({
                                  //         children: [
                                  //           new TableCell({
                                  //             children: [
                                  //               new Paragraph({
                                  //                 children: [
                                  //                   new TextRun({
                                  //                     text: ref.document || "",
                                  //                     font: "Montserrat",
                                  //                     size: 20,
                                  //                   }),
                                  //                 ],
                                  //               }),
                                  //             ],
                                  //           }),
                                  //           new TableCell({
                                  //             children: [
                                  //               new Paragraph({
                                  //                 children: [
                                  //                   new TextRun({
                                  //                     text: ref.relevance || "",
                                  //                     font: "Montserrat",
                                  //                     size: 20,
                                  //                   }),
                                  //                 ],
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       })
                                  // ),
                                  ...references.map((ref) =>
                                    ref.type === "heading"
                                      ? new TableRow({
                                        height: { value: 250 }, // slightly taller heading row
                                        children: [
                                          new TableCell({
                                            columnSpan: 2,
                                            shading: { fill: "FFF7D7" }, // light yellow
                                            verticalAlign: VerticalAlign.CENTER,
                                            children: [
                                              new Paragraph({
                                                alignment: AlignmentType.LEFT, // headings left aligned
                                                children: [
                                                  new TextRun({
                                                    text: ref.section_name || "",
                                                    bold: true,
                                                    font: "Montserrat",
                                                    size: 19,
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                        ],
                                      })
                                      : new TableRow({
                                        height: { value: 350 }, // increase data row height
                                        children: [
                                          new TableCell({
                                            verticalAlign: VerticalAlign.CENTER, // vertical center
                                            children: [
                                              new Paragraph({

                                                children: [
                                                  new TextRun({
                                                    text: ref.document || "",
                                                    font: "Montserrat",
                                                    size: 18,
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                          new TableCell({
                                            verticalAlign: VerticalAlign.CENTER, // vertical center
                                            children: [
                                              new Paragraph({

                                                children: [
                                                  new TextRun({
                                                    text: ref.relevance || "",
                                                    font: "Montserrat",
                                                    size: 18,
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                        ],
                                      })
                                  )

                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              },
            ]
            : []),












          //understanding reports for Electrical
          ...(reportType !== "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          // shading: {
                          //   fill: "#02075d",
                          // },
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "UNDERSTANDING THE REPORT",
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 25,
                                  bold: true,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break
                            ...contentParagraph3,        // your content with same left/right spacing
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

              ],
            },] : []),

          //executive summary for electrical
          ...(reportType !== "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "1. Executive Summary",
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 25,
                                  bold: true,
                                }),
                              ],
                              break: 1,
                            }),
                            new Paragraph({ break: 1 }), // line break  
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),

                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        // fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        // left: 200,
                                        // right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        // fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        // left: 200,
                                        // right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryFindingsParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        // fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        // left: 200,
                                        // right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...executiveSummaryKeyObservationsParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),


              ],
            },] : []),





          // improvement opportunity areas for electrical
          ...(reportType !== "HSE"
            ? [
              {

                properties: {
                  // type: SectionType.CONTINUOUS,
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838,   // 29.7 cm
                    //   height: 11906,  // 21 cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                      bottom: 500,
                    }
                  }
                },
                children: [
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: {
                              size: 100, // Adjust width as needed
                              type: WidthType.PERCENTAGE,
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: ``,
                                    size: 30,
                                    font: "Montserrat",
                                    color: "#ffffff", // Adjust text color for visibility
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: {
                                      width: 120,
                                      height: 40,
                                    },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                        tableHeader: true,
                      }),
                    ],
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE,
                    },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1
                  }),
                  // Heading
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            shading: {
                              type: "clear",
                              color: "auto",
                            },
                            margins: {
                              left: 300,  // 1 inch left gap
                              right: 300, // 1 inch right gap
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: "2. Improvement Opportunity Areas",
                                    font: "Montserrat",
                                    color: "#307268",
                                    size: 25,
                                    bold: true,
                                  }),
                                ],

                              }),
                              new Paragraph({ break: 1 }), // line break
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),

                  // Yellow Box with content
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: {
                              left: 300,  // spacing outside yellow
                              right: 300,
                            },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              new Table({
                                rows: [
                                  new TableRow({
                                    children: [
                                      new TableCell({
                                        shading: {
                                          type: "clear",
                                          color: "auto",
                                          // fill: "fff8dc", // Light cream-yellow
                                        },
                                        margins: {
                                          top: 200,    // padding inside yellow
                                          bottom: 200,
                                          // left: 200,
                                          // right: 200,
                                        },
                                        borders: {
                                          top: { style: BorderStyle.NONE },
                                          bottom: { style: BorderStyle.NONE },
                                          left: { style: BorderStyle.NONE },
                                          right: { style: BorderStyle.NONE },
                                        },
                                        children: [
                                          ...improvementOpportunityParagraph3,
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),


                ],
              },
            ]
            : []),
          // overall risk indicator for electrical
          ...(reportType !== "HSE"
            ? [
              {
                properties: {
                  //  type: SectionType.CONTINUOUS,
                  page: {
                    orientation: PageOrientation.PORTRAIT,
                    // size: {
                    //   width: 16838,   // 29.7 cm
                    //   height: 11906,  // 21 cm
                    // },
                    margin: {
                      top: 500,
                      left: 500,
                      right: 500,
                      bottom: 500
                    }
                  }
                },
                children: [
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: {
                              size: 100, // Adjust width as needed
                              type: WidthType.PERCENTAGE,
                            },
                            children: [
                              new Paragraph({
                                children: [
                                  new TextRun({
                                    text: ``,
                                    size: 30,
                                    font: "Montserrat",
                                    color: "#ffffff", // Adjust text color for visibility
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                children: [
                                  new ImageRun({
                                    data: base64logo,
                                    transformation: {
                                      width: 120,
                                      height: 40,
                                    },
                                  }),
                                ],
                              }),
                            ],
                            verticalAlign: "center",
                          }),
                        ],
                        tableHeader: true,
                      }),
                    ],
                    width: {
                      size: 100,
                      type: WidthType.PERCENTAGE,
                    },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),
                  new Paragraph({
                    children: [new TextRun("")],
                    break: 1
                  }),


                  // Heading
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "3. Overall Risk Assessment Indicator",
                        font: "Montserrat",
                        color: "#307268",
                        size: 25,
                        bold: true,
                      }),
                    ],
                    spacing: {
                      after: 200, // space after paragraph
                    },
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                  }),


                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: { left: 300, right: 300 }, // spacing from page edges
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Inner table → Left-right percentage layout
                              new Table({
                                rows: [
                                  new TableRow({
                                    children: [
                                      // LEFT CELL → Fixed width yellow box
                                      new TableCell({
                                        // width: { size: 20, type: WidthType.PERCENTAGE },
                                        width: { size: 2040, type: WidthType.DXA },
                                        // shading: { fill: "FFD700" },
                                        shading: { fill: boxColor },
                                        // Top-anchored so the score/label sit at the top of the
                                        // box (aligned with the first line of the right-cell text)
                                        // instead of vertically centered.
                                        verticalAlign: VerticalAlign.TOP,
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            spacing: { before: 200 },
                                            children: [
                                              new TextRun({
                                                //  text: `${((cumulativeScore / 10) * 100).toFixed(2)}%`,
                                                text: `${Math.floor((cumulativeScore / 25) * 100)}%`,
                                                bold: true, size: 48,
                                                color: "000000",
                                              }),
                                            ],
                                          }),
                                          // Risk label shown under the percentage. Derived from the
                                          // displayed score (indicatorRisk) so it matches the score and
                                          // ExportSavedReportPDF's "3. Overall Risk Assessment Indicator".
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            spacing: { before: 120 },
                                            children: [
                                              new TextRun({
                                                text: indicatorRisk?.risk || "",
                                                bold: true,
                                                size: 24,
                                                color: "000000",
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),

                                      // RIGHT CELL → Dynamic content (80%, matching the PDF flex 2:8 split)
                                      new TableCell({
                                        width: { size: 8160, type: WidthType.DXA },
                                        margins: { top: 200, bottom: 200, left: 300, right: 300 },
                                        borders: {
                                          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                        },
                                        children: [
                                          ...overallAssessmentParagraph3, // your content here
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                                // Fixed layout + explicit column widths so Word honors the
                                // 20/80 split instead of autofitting columns to content.
                                // Total fits the section content area (A4 portrait, 500 margins,
                                // less the outer cell's 300 margins) so it doesn't overflow.
                                width: { size: 10200, type: WidthType.DXA },
                                layout: TableLayoutType.FIXED,
                                columnWidths: [2040, 8160],
                                borders: {
                                  top: { style: BorderStyle.NONE },
                                  bottom: { style: BorderStyle.NONE },
                                  left: { style: BorderStyle.NONE },
                                  right: { style: BorderStyle.NONE },
                                  insideHorizontal: { style: BorderStyle.NONE },
                                  insideVertical: { style: BorderStyle.NONE },
                                },
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),





                  new Paragraph({ break: 1 }),
                  new Paragraph({ break: 1 }),
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Risk Legend",
                        font: "Montserrat",
                        color: "#307268",
                        size: 25,
                        bold: true,
                      }),
                    ],
                    spacing: {
                      before: 5500,
                      after: 100, // space after paragraph
                    },
                    indent: {
                      left: 300,   // left indentation (~0.7 inch)

                    },
                  }),
                  // new Paragraph({
                  //   children: [
                  //     new TextRun({
                  //       // text: "The above image is for display purposes only",
                  //       font: "Montserrat",

                  //       size: 22,
                  //       bold: false,
                  //     }),
                  //   ],
                  //   spacing: {
                  //     after: 200, // space after paragraph
                  //   },
                  //   indent: {
                  //     left: 300,   // left indentation (~0.7 inch)

                  //   },
                  // }),
                  new Paragraph({ break: 1 }),
                  // --- New Table: Risk Levels ---
                  new Table({
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            margins: { left: 300, right: 300 },
                            borders: {
                              top: { style: BorderStyle.NONE },
                              bottom: { style: BorderStyle.NONE },
                              left: { style: BorderStyle.NONE },
                              right: { style: BorderStyle.NONE },
                            },
                            children: [
                              // Inner table → your actual risk levels table
                              new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE }, // full width inside the cell
                                borders: {
                                  top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                  insideVertical: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                                rows: [
                                  // Header Row
                                  //                 new TableRow({
                                  //                   children: ["Score Range", "Risk Level", "Interpretation"].map((text) =>
                                  //                     new TableCell({
                                  //                       shading: { fill: "#307260" },
                                  //                       children: [
                                  //                         new Paragraph({
                                  //                           alignment: AlignmentType.CENTER,
                                  //                           children: [
                                  //                             new TextRun({
                                  //                               text,
                                  //                               bold: true,
                                  //                               color: "#efc71d",
                                  //                               size: 24,
                                  //                             }),
                                  //                           ],
                                  //                         }),
                                  //                       ],
                                  //                     })
                                  //                   ),
                                  //                 }),
                                  //                 // Data Rows
                                  //                ...riskLevels.map((level) =>
                                  //   new TableRow({
                                  //     children: [
                                  //       // Score Range → colored
                                  //       new TableCell({
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             alignment: AlignmentType.CENTER,
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.range,
                                  //                 color: level.color, // use respective color
                                  //                 size: 20, // decrease by 1 from 25
                                  //                 bold:true
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),

                                  //       new TableCell({
                                  //         shading: { fill: level.color },
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             alignment: AlignmentType.CENTER,
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.risk,
                                  //                 bold: false, // remove bold
                                  //                 size: 20, // decrease by 1
                                  //                 color: "#000000", // optional: black text on colored background
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),
                                  //       // Interpretation → normal text, smaller size
                                  //       new TableCell({
                                  //         margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                  //         children: [
                                  //           new Paragraph({
                                  //             children: [
                                  //               new TextRun({
                                  //                 text: level.interpretation,
                                  //                 size: 20, // decrease by 1
                                  //               }),
                                  //             ],
                                  //           }),
                                  //         ],
                                  //       }),
                                  //     ],
                                  //   })
                                  // ),
                                  new TableRow({
                                    height: { value: 500, rule: HeightRule.EXACT }, // Increase height
                                    children: [
                                      new TableCell({
                                        width: { size: 2000, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,        // Vertical center
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,        // Horizontal center
                                            children: [new TextRun({ text: "Score Range", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),

                                      new TableCell({
                                        width: { size: 400, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [new TextRun({ text: "Risk Level", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),

                                      new TableCell({
                                        width: { size: 9600, type: WidthType.DXA },
                                        verticalAlign: VerticalAlign.CENTER,
                                        shading: { fill: "#307260" },
                                        children: [
                                          new Paragraph({
                                            alignment: AlignmentType.CENTER,
                                            children: [new TextRun({ text: "Interpretation", bold: true, color: "#efc71d", size: 18 })],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  ...riskLevels.map((level) =>
                                    new TableRow({
                                      height: { value: 600, rule: HeightRule.EXACT }, // Bigger height for data
                                      children: [
                                        // Score Range
                                        new TableCell({
                                          width: { size: 3500, type: WidthType.DXA },
                                          verticalAlign: VerticalAlign.CENTER,
                                          children: [
                                            new Paragraph({
                                              alignment: AlignmentType.CENTER,
                                              children: [
                                                new TextRun({
                                                  text: level.range,
                                                  color: level.color,
                                                  size: 18,
                                                  bold: true,
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),

                                        // Risk Level
                                        new TableCell({
                                          width: { size: 3500, type: WidthType.DXA },
                                          shading: { fill: level.color },
                                          verticalAlign: VerticalAlign.CENTER,
                                          children: [
                                            new Paragraph({
                                              alignment: AlignmentType.CENTER,
                                              children: [
                                                new TextRun({
                                                  text: level.risk,
                                                  size: 18,
                                                  color: "#000000",
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),

                                        // Interpretation
                                        new TableCell({
                                          width: { size: 5000, type: WidthType.DXA },
                                          verticalAlign: VerticalAlign.CENTER,
                                          //  margins: { top: 100, bottom: 100, left: 200, right: 200 },
                                          margins: { left: 200, right: 200 },
                                          children: [
                                            new Paragraph({
                                              // alignment: AlignmentType.CENTER, 
                                              children: [
                                                new TextRun({
                                                  text: level.interpretation,
                                                  size: 18,
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),
                                      ],
                                    })
                                  ),


                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                      top: { style: BorderStyle.NONE },
                      bottom: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                      insideHorizontal: { style: BorderStyle.NONE },
                      insideVertical: { style: BorderStyle.NONE },
                    },
                  }),




                ],


              },
            ]
            : [
            ]),




          reportType === "HSE" ?
            {
              properties: {

                page: {
                  orientation: PageOrientation.LANDSCAPE,
                  size: {
                    width: 16838,   // 29.7 cm
                    height: 11906,  // 21 cm
                  },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500,
                  },
                  size: {
                    orientation: PageOrientation.LANDSCAPE
                  }
                },
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100,
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff",
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          shading: {
                            fill: "#ffffff",
                          },
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          shading: {
                            fill: "#ffffff",
                          },
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: reportType === "HSE" ? "Critical Observations, Recommendations & Reasoning - HSE Report" : "4. Critical Observations, Recommendations & Reasoning - Electrical Report",
                      font: "Montserrat",
                      color: "#307268",
                      size: 28,
                      bold: true,
                    }),
                  ],
                  indent: {
                    left: reportType === "HSE" ? 0 : 1000,
                  },
                  break: 1,
                }),

                ...(groupedObservations && typeof groupedObservations === 'object' ? Object.keys(groupedObservations).flatMap((tableType, index) => {
                  const observations = groupedObservations[tableType];
                  if (!observations || observations.length === 0) {
                    return [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `${index + 1}. ${tableType} - No observations selected`,
                            font: "Arial",
                            size: 24,
                            bold: true,
                            color: "#ff0000",
                          }),
                        ],
                        indent: { left: 800 },
                        spacing: { before: 200 },
                      }),
                    ];
                  }

                  return [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `${index + 1}. ${tableType}`,
                          font: "Arial",
                          size: 25,
                          bold: true,
                          color: "#307268",
                        }),
                      ],
                      indent: { left: reportType === "HSE" ? 0 : 1000 },
                      spacing: { before: 200 },
                    }),
                    new Table({
                      layout: TableLayoutType.FIXED,
                      // Explicit grid (DXA) — fixed-layout Word sizes columns from this
                      // grid, not the per-cell widths. 11 columns (Check Point is
                      // commented out). Sr.No=532, Objective Evidence=2060, Observation &
                      // Recommendation (positions 7, 8) = 2160; total 15840 fits the
                      // landscape A4 printable width (~15838) with even left/right margins.
                      columnWidths: [532, 1584, 1584, 1296, 1152, 1182, 2160, 2160, 1326, 864, 2000],
                      width: {
                        size: 15840,
                        type: WidthType.DXA,
                      },
                      rows: [
                        new TableRow({
                          tableHeader: true,
                          children: [
                            new TableCell({

                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Sr. No.",
                                      bold: true,
                                      size: 18,
                                      color: "#FFFFFF",
                                    }),
                                  ],
                                }),
                              ],
                              shading: { fill: "#307268" },
                              width: { size: 0.3 * 1440, type: WidthType.DXA },
                              borders: {
                                top: { style: BorderStyle.SINGLE },
                                bottom: { style: BorderStyle.SINGLE },
                                left: { style: BorderStyle.SINGLE },
                                right: { style: BorderStyle.SINGLE },
                              },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                            ...(reportType === "HSE" ? [
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Area / Process",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 1 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Equipment",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 1 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Category",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 0.9 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              /* Check Point column hidden per request - kept for easy restore
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Check Point",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 1.2 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              */
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Criticality",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 0.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Status",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 0.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Observation",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 1 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Recommendation",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 1 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Legal Reference (if any)",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 0.9 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Score",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 0.6 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Objective Evidence",
                                        bold: true,
                                        size: 16,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                // Match the fixed table grid's last column (2000
                                // twips). The header, the data cell and the
                                // image were all using different widths, so
                                // Windows Word rendered this column narrower than
                                // the image and the picture spilled past the cell.
                                width: { size: 2000, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                            ] : [
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Area",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Categories",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Check Point",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Observation",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 6 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Criticality",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 2.5 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Recommendations",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 6 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Is Reference",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 2.5 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: "Photo Evidence",
                                        bold: true,
                                        size: 18,
                                        color: "#FFFFFF",
                                      }),
                                    ],
                                  }),
                                ],
                                shading: { fill: "#307268" },
                                width: { size: 4 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                            ]),
                            // ...(reportType === "HSE"
                            //   ? [
                            //     new TableCell({
                            //       children: [
                            //         new Paragraph({
                            //           alignment: AlignmentType.CENTER,
                            //           children: [
                            //             new TextRun({
                            //               text: "Score",
                            //               bold: true,
                            //               size:18,
                            //               color: "#efc71d",
                            //             }),
                            //           ],
                            //         }),
                            //       ],
                            //       shading: { fill: "#307268" },
                            //       width: { size: 2.5 * 1440, type: WidthType.DXA },
                            //       borders: {
                            //         top: { style: BorderStyle.SINGLE },
                            //         bottom: { style: BorderStyle.SINGLE },
                            //         left: { style: BorderStyle.SINGLE },
                            //         right: { style: BorderStyle.SINGLE },
                            //       },
                            //       verticalAlign: VerticalAlign.CENTER,
                            //     }),
                            //   ]
                            //   : []),
                            //   new TableCell({
                            //   children: [
                            //     new Paragraph({
                            //       alignment: AlignmentType.CENTER,
                            //       children: [
                            //         new TextRun({
                            //           text: "system implementation",
                            //           bold: true,
                            //           size:18,
                            //           color: "#efc71d",
                            //         }),
                            //       ],
                            //     }),
                            //   ],
                            //   shading: { fill: "#307268" },
                            //   width: { size: 7 * 1440, type: WidthType.DXA },
                            //   borders: {
                            //     top: { style: BorderStyle.SINGLE },
                            //     bottom: { style: BorderStyle.SINGLE },
                            //     left: { style: BorderStyle.SINGLE },
                            //     right: { style: BorderStyle.SINGLE },
                            //   },
                            //   verticalAlign: VerticalAlign.CENTER,
                            // }),
                            // new TableCell({
                            //   children: [
                            //     new Paragraph({
                            //       alignment: AlignmentType.CENTER,
                            //       children: [
                            //         new TextRun({
                            //           text: "compliance check",
                            //           bold: true,
                            //           size:18,
                            //           color: "#efc71d",
                            //         }),
                            //       ],
                            //     }),
                            //   ],
                            //   shading: { fill: "#307268" },
                            //   width: { size: 7 * 1440, type: WidthType.DXA },
                            //   borders: {
                            //     top: { style: BorderStyle.SINGLE },
                            //     bottom: { style: BorderStyle.SINGLE },
                            //     left: { style: BorderStyle.SINGLE },
                            //     right: { style: BorderStyle.SINGLE },
                            //   },
                            //   verticalAlign: VerticalAlign.CENTER,
                            // }),
                            // new TableCell({
                            //   children: [
                            //     new Paragraph({
                            //       alignment: AlignmentType.CENTER,
                            //       children: [
                            //         new TextRun({
                            //           text: "Photo Evidence",
                            //           bold: true,
                            //           size:18,
                            //           color: "#efc71d",
                            //         }),
                            //       ],
                            //     }),
                            //   ],
                            //   shading: { fill: "#307268" },
                            //   width: { size: 4 * 1440, type: WidthType.DXA },
                            //   borders: {
                            //     top: { style: BorderStyle.SINGLE },
                            //     bottom: { style: BorderStyle.SINGLE },
                            //     left: { style: BorderStyle.SINGLE },
                            //     right: { style: BorderStyle.SINGLE },
                            //   },
                            //   verticalAlign: VerticalAlign.CENTER,
                            // }),
                          ],

                        }),
                        ...observations.map((obs, index) => new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun(`${index + 1}`)] })],
                              width: { size: 0.3 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                              borders: {
                                top: { style: BorderStyle.SINGLE },
                                bottom: { style: BorderStyle.SINGLE },
                                left: { style: BorderStyle.SINGLE },
                                right: { style: BorderStyle.SINGLE },
                              },
                            }),
                            ...(reportType === "HSE" ? [
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.area || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 1.2 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.equipment || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 1.2 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.category || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 1.0 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              /* Check Point column hidden per request - kept for easy restore
                              new TableCell({
                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                children: textToBulletParagraphs(obs.check_points),
                                width: { size: 1.2 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              */
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.criticality || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 0.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.status || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 0.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                children: textToBulletParagraphs(obs.observation),
                                width: { size: 1.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                children: textToBulletParagraphs(obs.recommendations),
                                width: { size: 1.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.legal_reference || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 0.8 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),

                              // NEW SCORE COLUMN
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text:
                                          obs.score !== undefined &&
                                            obs.score !== null
                                            ? String(obs.score)
                                            : "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 0.6 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),

                              new TableCell({
                                children: Array.isArray(obs.imageUrls) && obs.imageUrls.length > 0
                                  ? obs.imageUrls.map(image => {
                                    // Scale to the real column width (2000 twips
                                    // ≈ 1.389") while preserving the image's own
                                    // aspect ratio, so it fills the Objective
                                    // Evidence column like the PDF, stays inside
                                    // the cell in Windows Word, and isn't
                                    // stretched/squashed.
                                    const dims = getAspectFitDimensions(image, 2000 / 1440, obs.imageUrls.length);
                                    return new Paragraph({
                                      alignment: AlignmentType.CENTER,
                                      spacing: { before: 10, after: 10 },
                                      children: [
                                        new ImageRun({
                                          data: image,
                                          transformation: dims,
                                        }),
                                      ],
                                    });
                                  })
                                  : [new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [new TextRun("N/A")],
                                  })],
                                width: { size: 2000, type: WidthType.DXA },
                                margins: { top: 0, bottom: 0, left: 0, right: 0 },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.TOP,
                              }),
                            ] : [
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.area || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.category || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.check_points || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 3 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.observation || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 6 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.criticality || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 2.5 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                children: textToBulletParagraphs(obs.recommendations),
                                width: { size: 6.2 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: [
                                  new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                      new TextRun({
                                        text: obs.is_reference || "N/A",
                                        size: 18,
                                      }),
                                    ],
                                  }),
                                ],
                                width: { size: 2.5 * 1440, type: WidthType.DXA },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                                verticalAlign: VerticalAlign.CENTER,
                              }),
                              new TableCell({
                                children: Array.isArray(obs.imageUrls) && obs.imageUrls.length > 0
                                  ? obs.imageUrls.map(image => {
                                    const dims = getResponsiveImageDimensions(4, obs.imageUrls.length);
                                    return new Paragraph({
                                      alignment: AlignmentType.CENTER,
                                      spacing: { before: 10, after: 10 },
                                      children: [
                                        new ImageRun({
                                          data: image,
                                          transformation: dims,
                                        }),
                                      ],
                                    });
                                  })
                                  : [new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [new TextRun("N/A")],
                                  })],
                                width: { size: 4 * 1440, type: WidthType.DXA },
                                margins: { top: 0, bottom: 0, left: 0, right: 0 },
                                borders: {
                                  top: { style: BorderStyle.SINGLE },
                                  bottom: { style: BorderStyle.SINGLE },
                                  left: { style: BorderStyle.SINGLE },
                                  right: { style: BorderStyle.SINGLE },
                                },
                              }),
                            ]),

                            //                             ...(reportType === "HSE"
                            //                               ? [
                            //                                 new TableCell({
                            //                                   // children: [
                            //                                   //   new Paragraph({ text: obs.score ? obs.score.toString() : "N/A", alignment: AlignmentType.CENTER }),
                            //                                   // ],
                            //                                   children: [
                            //   new Paragraph({
                            //     alignment: AlignmentType.CENTER,
                            //     children: [
                            //       new TextRun({
                            //         text: obs.score ? obs.score.toString() : "N/A",
                            //         size:18, // 12pt font size
                            //       }),
                            //     ],
                            //   }),
                            // ],

                            //                                   width: { size: 2.5 * 1440, type: WidthType.DXA },
                            //                                   borders: {
                            //                                     top: { style: BorderStyle.SINGLE },
                            //                                     bottom: { style: BorderStyle.SINGLE },
                            //                                     left: { style: BorderStyle.SINGLE },
                            //                                     right: { style: BorderStyle.SINGLE },
                            //                                   },
                            //                                   verticalAlign: VerticalAlign.CENTER,
                            //                                 }),
                            //                               ]
                            //                               : []),
                            //                                new TableCell({
                            //                             // children: [new Paragraph(obs.system_implementation || "N/A")],
                            //                              children: [
                            //   new Paragraph({
                            //     alignment: AlignmentType.CENTER,
                            //     children: [
                            //       new TextRun({
                            //         text: obs.system_implementation,
                            //         size:18,
                            //       }),
                            //     ],
                            //   }),
                            // ],
                            //                             width: { size: 7 * 1440, type: WidthType.DXA },
                            //                             borders: {
                            //                               top: { style: BorderStyle.SINGLE },
                            //                               bottom: { style: BorderStyle.SINGLE },
                            //                               left: { style: BorderStyle.SINGLE },
                            //                               right: { style: BorderStyle.SINGLE },
                            //                             },
                            //                              verticalAlign: VerticalAlign.CENTER,
                            //                           }),
                            //                              new TableCell({
                            //                             // children: [new Paragraph(obs.compliance_check || "N/A")],
                            //                              children: [
                            //   new Paragraph({
                            //     alignment: AlignmentType.CENTER,
                            //     children: [
                            //       new TextRun({
                            //         text: obs.compliance_check,
                            //         size:18,
                            //       }),
                            //     ],
                            //   }),
                            // ],
                            //                             width: { size: 7 * 1440, type: WidthType.DXA },
                            //                             borders: {
                            //                               top: { style: BorderStyle.SINGLE },
                            //                               bottom: { style: BorderStyle.SINGLE },
                            //                               left: { style: BorderStyle.SINGLE },
                            //                               right: { style: BorderStyle.SINGLE },
                            //                             },
                            //                           }),
                            // new TableCell({
                            //   children: [
                            //     new Paragraph({
                            //       alignment: AlignmentType.CENTER,
                            //       spacing: {
                            //       before: 100, // top padding (~0.1in)
                            //        after: 100,  // bottom padding (~0.1in)
                            //           },
                            //       children: Array.isArray(obs.imageUrls) && obs.imageUrls.length > 0
                            //         ? obs.imageUrls.map(image => new ImageRun({
                            //           data: image,
                            //           transformation: { width: 100, height: 70 },
                            //         }))
                            //         : [new TextRun("N/A")],
                            //     }),
                            //   ],
                            //   width: { size: 4 * 1440, type: WidthType.DXA },
                            //   verticalAlign: VerticalAlign.CENTER,
                            //   borders: {
                            //     top: { style: BorderStyle.SINGLE },
                            //     bottom: { style: BorderStyle.SINGLE },
                            //     left: { style: BorderStyle.SINGLE },
                            //     right: { style: BorderStyle.SINGLE },
                            //   },
                            // }),
                          ],
                        })),
                      ],
                      // width: { size: 100, type: WidthType.PERCENTAGE },
                      borders: {
                        top: { style: BorderStyle.SINGLE },
                        bottom: { style: BorderStyle.SINGLE },
                        left: { style: BorderStyle.SINGLE },
                        right: { style: BorderStyle.SINGLE },
                        insideHorizontal: { style: BorderStyle.SINGLE },
                        insideVertical: { style: BorderStyle.SINGLE },
                      },
                    }),
                  ];
                }) : []),
              ],
            } : {
              properties: {
                page: {
                  orientation: PageOrientation.LANDSCAPE,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  },
                  size: {
                    orientation: PageOrientation.LANDSCAPE
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          //  alignment: AlignmentType.CENTER,
                          width: {
                            size: 100,
                            type: WidthType.PERCENTAGE,

                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff",
                                }),
                              ],
                            }),
                          ],

                          verticalAlign: "center",

                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],

                          verticalAlign: "center",

                        }),
                      ],
                      tableHeader: true,

                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Paragraph({
                  children: [new TextRun({
                    text: reportType === "HSE" ? "5. Critical Observations, Recommendations & Reasoning - HSE Report" : "4. Critical Observations, Recommendations & Reasoning - Electrical Report",
                    font: "Montserrat",
                    color: "#307268",
                    size: 25,
                    bold: true,
                  })],
                  break: 1,
                  alignment: AlignmentType.LEFT,
                  indent: {
                    left: 200,
                  }
                }),
                new Paragraph({ break: 1 }),
                new Table({
                  width: {
                    size: 15438,
                    type: WidthType.DXA,
                  },
                  rows: [
                    new TableRow({
                      height: { value: 600, rule: HeightRule.EXACT },
                      tableHeader: true,
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Sr. No",
                                  bold: true,
                                  size: 22,
                                  color: "#efc71d",
                                }),
                              ],
                            }),
                          ],
                          shading: {
                            fill: "#307268",
                          },
                          width: {
                            size: 0.5 * 1440,
                            type: WidthType.DXA,
                          },
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        ...(reportType === "HSE" ? [
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Area / Process",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2.5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Equipment",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2.5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Category",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          /* Check Point column hidden per request - kept for easy restore
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Check Point",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2.5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          */
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Criticality",
                                    bold: true,
                                    color: "#efc71d",
                                    size: 22,
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Status",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Observation",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Recommendation",
                                    bold: true,
                                    color: "#efc71d",
                                    size: 22,
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Legal Reference (if any)",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 3 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                        ] : [
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Area",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 3 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          // new TableCell({
                          //   children: [
                          //     new Paragraph({
                          //       alignment: AlignmentType.CENTER,
                          //       children: [
                          //         new TextRun({
                          //           text: "Categories",
                          //           bold: true,
                          //           size: 22,
                          //           color: "#efc71d",
                          //         }),
                          //       ],
                          //     }),
                          //   ],
                          //   shading: {
                          //     fill: "#307268",
                          //   },
                          //   width: {
                          //     size: 3 * 1440,
                          //     type: WidthType.DXA,
                          //   },
                          //   verticalAlign: VerticalAlign.CENTER,
                          // }),
                          // new TableCell({
                          //   children: [
                          //     new Paragraph({
                          //       alignment: AlignmentType.CENTER,
                          //       children: [
                          //         new TextRun({
                          //           text: "Check Point",
                          //           bold: true,
                          //           size: 22,
                          //           color: "#efc71d",
                          //         }),
                          //       ],
                          //     }),
                          //   ],
                          //   shading: {
                          //     fill: "#307268",
                          //   },
                          //   width: {
                          //     size: 3 * 1440,
                          //     type: WidthType.DXA,
                          //   },
                          //   verticalAlign: VerticalAlign.CENTER,
                          // }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Observation",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 6 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Criticality",
                                    bold: true,
                                    color: "#efc71d",
                                    size: 22,
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2.5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Recommendations",
                                    bold: true,
                                    color: "#efc71d",
                                    size: 22,
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 6 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Is Reference",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 2.5 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                  new TextRun({
                                    text: "Photo Evidence",
                                    bold: true,
                                    size: 22,
                                    color: "#efc71d",
                                  }),
                                ],
                              }),
                            ],
                            shading: {
                              fill: "#307268",
                            },
                            width: {
                              size: 4 * 1440,
                              type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                        ]),
                      ],
                    }),
                    ...selectedObsCopy.map((observation, index) => {
                      const rowBase64Images = observation.imageUrls || [];

                      return new TableRow({
                        children: [
                          new TableCell({
                            children: [
                              new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [new TextRun(`${index + 1}`)]
                              })
                            ],
                            width: { size: 0.5 * 1440, type: WidthType.DXA },
                            verticalAlign: VerticalAlign.CENTER,
                          }),
                          ...(reportType === "HSE" ? [
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [new Paragraph({ children: [new TextRun(observation.area || "N/A")] })],
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 2.5 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [new Paragraph({ children: [new TextRun(observation.equipment || "N/A")] })],
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 2.5 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [new Paragraph({ children: [new TextRun(observation.category || "N/A")] })],
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 2 * 1440, type: WidthType.DXA },
                            }),
                            /* Check Point column hidden per request - kept for easy restore
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [new Paragraph({ children: [new TextRun(observation.check_points || "N/A")] })],
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 2.5 * 1440, type: WidthType.DXA },
                            }),
                            */
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun(observation.criticality || "N/A")]
                                })
                              ],
                              width: { size: 2 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun(observation.status || "N/A")]
                                })
                              ],
                              width: { size: 2 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: textToBulletParagraphs(observation.observation),
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 5 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: textToBulletParagraphs(observation.recommendations),
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 5 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun(observation.legal_reference || "N/A")]
                                })
                              ],
                              width: { size: 3 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                          ] : [
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [new Paragraph({ children: [new TextRun(observation.area || "N/A")] })],
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 3 * 1440, type: WidthType.DXA },
                            }),
                            // new TableCell({
                            //   margins: { top: 100, bottom: 100, left: 100, right: 100 },
                            //   children: [new Paragraph({ children: [new TextRun(observation.category || "N/A")] })],
                            //   verticalAlign: VerticalAlign.CENTER,
                            //   width: { size: 3 * 1440, type: WidthType.DXA },
                            // }),
                            // new TableCell({
                            //   margins: { top: 100, bottom: 100, left: 100, right: 100 },
                            //   children: [new Paragraph({ children: [new TextRun(observation.check_points || "N/A")] })],
                            //   verticalAlign: VerticalAlign.CENTER,
                            //   width: { size: 3 * 1440, type: WidthType.DXA },
                            // }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: textToBulletParagraphs(observation.observation),
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 6 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun(observation.criticality || "N/A")]
                                })
                              ],
                              width: { size: 2.5 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: textToBulletParagraphs(observation.recommendations),
                              verticalAlign: VerticalAlign.CENTER,
                              width: { size: 6 * 1440, type: WidthType.DXA },
                            }),
                            new TableCell({
                              margins: { top: 100, bottom: 100, left: 100, right: 100 },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun(observation.is_reference || "N/A")]
                                })
                              ],
                              width: { size: 2.5 * 1440, type: WidthType.DXA },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                            new TableCell({
                              children: Array.isArray(observation.imageUrls) && observation.imageUrls.length > 0
                                ? observation.imageUrls.map(image => {
                                  // let img = Object.values(image)[0];
                                  const dims = getResponsiveImageDimensions(4, observation.imageUrls.length);
                                  return new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    spacing: { before: 10, after: 10 },
                                    children: [
                                      new ImageRun({
                                        data: image,
                                        transformation: dims,
                                      }),
                                    ],
                                  });
                                })
                                : [new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [new TextRun("N/A")],
                                })],
                              width: { size: 4 * 1440, type: WidthType.DXA },
                              margins: { top: 0, bottom: 0, left: 0, right: 0 },
                              verticalAlign: VerticalAlign.CENTER,
                            }),
                          ]),
                        ],
                      });
                    }),
                  ],
                })
              ],

            },

          ...(reportType === "HSE" && chartImage
            ? [{
              properties: {
                page: {
                  // Portrait to match the PDF dashboard page.
                  orientation: PageOrientation.PORTRAIT,
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500,
                  },
                },
              },

              children: [
                new Table({
                  // Match the borderless logo header used by every other HSE
                  // section. Without table-level borders, the docx library
                  // falls back to default single borders, which rendered as an
                  // empty boxed "header" rectangle on the Dashboard page.
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 70, type: WidthType.PERCENTAGE },
                          children: [new Paragraph({ text: "" })],
                          shading: { fill: "#ffffff" },
                        }),
                        new TableCell({
                          width: { size: 30, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.RIGHT,
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          shading: { fill: "#ffffff" },
                        }),
                      ],
                    }),
                  ],
                }),

                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Dashboard",
                      font: "Montserrat",
                      size: 28,
                      bold: true,
                      color: "#307268",
                    }),
                  ],
                  spacing: {
                    before: 300,
                    after: 300,
                  },
                }),

                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  spacing: {
                    before: 200,
                    after: 200,
                  },
                  children: [
                    new ImageRun({
                      data: chartImage,
                      // Match the PDF: render the captured chart at its natural
                      // aspect ratio scaled to the portrait page width, instead
                      // of stretching it into a fixed box (which squished the
                      // tall, near-square dashboard).
                      transformation: (() => {
                        const MAX_W = 720; // portrait A4 content width @96dpi
                        const MAX_H = 820; // keep chart + heading on one page
                        let w = MAX_W;
                        let h = Math.round(MAX_W / 0.947); // fallback ratio
                        try {
                          const b64 = (chartImage || "").split(",")[1] || "";
                          const bin = atob(b64.slice(0, 64));
                          const u32 = (i) =>
                            ((bin.charCodeAt(i) << 24) |
                              (bin.charCodeAt(i + 1) << 16) |
                              (bin.charCodeAt(i + 2) << 8) |
                              bin.charCodeAt(i + 3)) >>> 0;
                          const nw = u32(16); // PNG IHDR width
                          const nh = u32(20); // PNG IHDR height
                          if (nw > 0 && nh > 0) {
                            h = Math.round((MAX_W * nh) / nw);
                            if (h > MAX_H) {
                              h = MAX_H;
                              w = Math.round((MAX_H * nw) / nh);
                            }
                          }
                        } catch (e) {
                          // keep the fallback dimensions
                        }
                        return { width: w, height: h };
                      })(),
                    }),
                  ],
                }),
              ],
            }]
            : []),

          ...(reportType !== "HSE"
            ? [{
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 70, type: WidthType.PERCENTAGE },
                          children: [new Paragraph({ text: "" })],
                          shading: { fill: "#ffffff" },
                        }),
                        new TableCell({
                          width: { size: 30, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.RIGHT,
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: { width: 120, height: 40 },
                                }),
                              ],
                            }),
                          ],
                          shading: { fill: "#ffffff" },
                        }),
                      ],
                    }),
                  ],
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "5. Scoring Table",
                      font: "Montserrat",
                      color: "#307268",
                      size: 25,
                      bold: true,
                    }),
                  ],
                  indent: { left: 300 },
                  spacing: { after: 200 }, // add gap instead of break
                  keepNext: true,          // keep with next content
                }),

                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,
                            right: 1000,
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Table({
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                insideVertical: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                              },
                              rows: [
                                // Header row
                                new TableRow({

                                  children: [
                                    new TableCell({
                                      shading: { fill: "#307260" },
                                      margins: {
                                        left: 140,
                                      },
                                      children: [
                                        new Paragraph({
                                          alignment: AlignmentType.LEFT,
                                          children: [
                                            new TextRun({
                                              text: "Parameter",
                                              bold: true,
                                              color: "#efc71d",
                                              size: 22,
                                            }),
                                          ],
                                          // shading: { fill: "#307260" },
                                        }),
                                      ],
                                    }),
                                    new TableCell({
                                      shading: { fill: "#307260" },
                                      children: [
                                        new Paragraph({
                                          alignment: AlignmentType.CENTER,
                                          children: [
                                            new TextRun({
                                              text: "Max Score",
                                              bold: true,
                                              color: "#efc71d",
                                              size: 22,
                                            }),
                                          ],
                                          // shading: { fill: "#307260" },
                                        }),
                                      ],
                                    }),
                                    new TableCell({
                                      shading: { fill: "#307260" },
                                      children: [
                                        new Paragraph({
                                          alignment: AlignmentType.CENTER,
                                          children: [
                                            new TextRun({
                                              text: "Score Obtained",
                                              bold: true,
                                              color: "#efc71d",
                                              size: 22,
                                            }),
                                          ],

                                        }),
                                      ],
                                    }),
                                  ],
                                }),

                                // Data rows
                                // ...scores.map(
                                //   (score) =>
                                //     new TableRow({
                                //       children: [
                                //         new TableCell({
                                //           children: [
                                //             new Paragraph({
                                //               children: [
                                //                 new TextRun({
                                //                   text: score["Electrical Safety"],
                                //                   bold: true,
                                //                 }),
                                //               ],
                                //             }),
                                //           ],
                                //           margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //         }),
                                //         new TableCell({
                                //           children: [
                                //             new Paragraph({
                                //               children: [
                                //                 new TextRun({
                                //                   text: score["Maximum Score"].toString(),
                                //                   bold: true,
                                //                 }),
                                //               ],
                                //               alignment: AlignmentType.CENTER,
                                //             }),
                                //           ],
                                //           margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //         }),
                                //         new TableCell({
                                //           children: [
                                //             new Paragraph({
                                //               children: [
                                //                 new TextRun({
                                //                   text: score["Score Obtained"].toString(),
                                //                   bold: true,
                                //                 }),
                                //               ],
                                //               alignment: AlignmentType.CENTER,
                                //             }),
                                //           ],
                                //           margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //         }),
                                //       ],
                                //     })
                                //     ),
                                ...scores.map(
                                  (score) =>
                                    new TableRow({
                                      children: [
                                        // PARAMETER (NAME)
                                        new TableCell({
                                          children: [
                                            new Paragraph({
                                              children: [
                                                new TextRun({
                                                  text: score.parameter,
                                                  bold: true,
                                                }),
                                              ],
                                            }),
                                          ],
                                          margins: { top: 120, bottom: 120, left: 100, right: 100 },
                                        }),

                                        // MAX SCORE
                                        new TableCell({
                                          children: [
                                            new Paragraph({
                                              children: [
                                                new TextRun({
                                                  text: score.MaximumScore.toString(),
                                                  bold: true,
                                                }),
                                              ],
                                              alignment: AlignmentType.CENTER,
                                            }),
                                          ],
                                          margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                        }),

                                        // SCORE OBTAINED
                                        new TableCell({
                                          children: [
                                            new Paragraph({
                                              children: [
                                                new TextRun({
                                                  text: score.ScoreObtained.toString(),
                                                  bold: true,
                                                }),
                                              ],
                                              alignment: AlignmentType.CENTER,
                                            }),
                                          ],
                                          margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                        }),
                                      ],
                                    })
                                ),


                                // Cumulative row
                                // new TableRow({
                                //   children: [
                                //     new TableCell({
                                //       children: [
                                //         new Paragraph({
                                //           children: [new TextRun({ text: "Cumulative", bold: true })],
                                //           alignment: AlignmentType.CENTER,
                                //         }),
                                //       ],
                                //       shading: { fill: "#efc71d" },
                                //       margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //     }),
                                //     new TableCell({
                                //       children: [
                                //         new Paragraph({
                                //           children: [new TextRun({ text: "25", bold: true })],
                                //           alignment: AlignmentType.CENTER,
                                //         }),
                                //       ],
                                //       shading: { fill: "#efc71d" },
                                //       margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //     }),
                                //     new TableCell({
                                //       children: [
                                //         new Paragraph({
                                //           children: [new TextRun({ text: cumulativeScore.toString(), bold: true })],
                                //           alignment: AlignmentType.CENTER,
                                //         }),
                                //       ],
                                //       shading: { fill: "#efc71d" },
                                //       margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                //     }),
                                //   ],
                                // }),
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      children: [
                                        new Paragraph({
                                          children: [new TextRun({ text: "Cumulative", bold: true })],
                                          alignment: AlignmentType.CENTER,
                                        }),
                                      ],
                                      shading: { fill: "#efc71d" },
                                      margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                    }),

                                    new TableCell({
                                      children: [
                                        new Paragraph({
                                          children: [
                                            new TextRun({
                                              text: scores
                                                .reduce((acc, s) => acc + s.MaximumScore, 0)
                                                .toString(),
                                              bold: true,
                                            }),
                                          ],
                                          alignment: AlignmentType.CENTER,
                                        }),
                                      ],
                                      shading: { fill: "#efc71d" },
                                      margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                    }),

                                    new TableCell({
                                      children: [
                                        new Paragraph({
                                          children: [
                                            new TextRun({
                                              text: cumulativeScore.toString(),
                                              bold: true,
                                            }),
                                          ],
                                          alignment: AlignmentType.CENTER,
                                        }),
                                      ],
                                      shading: { fill: "#efc71d" },
                                      margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                    }),
                                  ],
                                }),

                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                }),


                //     new Paragraph({
                //   children: [
                //     new TextRun({
                //       text: `Overall Score - ${((cumulativeScore / 10) * 100).toFixed(2)}%`,
                //       font: "Montserrat",
                //       color: "#efc71d",
                //       size: 25,
                //       bold: true,
                //     }),
                //   ],
                //   break: 1,
                //   indent:{
                //     left:1000,
                //     right:1000,
                //   }
                // }),
                // new Paragraph({ break: 1 }),

                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Overall Score: ",
                      font: "Montserrat",
                      color: "#307268",  // green text
                      size: 25,
                      bold: true,
                    }),
                    new TextRun({
                      text: `${((cumulativeScore / 25) * 100).toFixed(2)}%`,
                      font: "Montserrat",
                      color: "#a3a300",  // yellow percentage
                      size: 25,
                      bold: true,
                    }),
                  ],
                  break: 1,
                  indent: {
                    left: 300,
                    right: 1000,
                  },
                  spacing: { after: 4000, before: 500 },
                }),



                // chartImageElectrical &&
                //   new Table({
                //     rows: [
                //       new TableRow({
                //         children: [
                //           new TableCell({
                //             children: [
                //               new Paragraph({
                //                 alignment: AlignmentType.CENTER,
                //                 children: [
                //                   new ImageRun({
                //                     data: chartImageElectrical,
                //                     transformation: {
                //                       width: 500,
                //                       height: 300,
                //                     },
                //                   }),
                //                 ],
                //               }),
                //             ],
                //             borders: {
                //               top: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
                //               bottom: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
                //               left: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
                //               right: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
                //             },
                //           }),
                //         ],
                //       }),
                //     ],
                //     width: {
                //       size: 5000,
                //       type: WidthType.DXA,
                //     },
                //     indent: {
                //       size: 1000, // shifts the whole table 1000 twips (~0.7 inch) from left
                //       type: WidthType.DXA,
                //     },
                //   }),
                chartImageElectrical &&
                new Paragraph({
                  indent: {
                    left: 300,
                  },
                  children: [

                    new ImageRun({
                      data: chartImageElectrical,
                      transformation: { width: 650, height: 350 },
                    }),
                  ],
                }),
              ],
            }]
            : []),

          //  way forward for electrical
          ...(reportType !== "HSE" ? [
            {
              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],

                          verticalAlign: "center",

                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,

                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Paragraph({
                  children: [new TextRun({
                    text: "6. Way Forward Plan",
                    font: "Montserrat",
                    color: "#307268",
                    size: 25,
                    bold: true
                  })],
                  break: 1,
                  indent: {
                    left: 300,   // 720 = 0.5 inch left margin
                    right: 300,  // 720 = 0.5 inch right margin
                  },
                }),
                new Paragraph({ break: 1 }), // Line break after the heading
                // ...theWayForwardParagraph3,
                // Header (outside the block)


                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        // fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        // left: 200,
                                        // right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...theWayForwardParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({ break: 1 }),
                new Paragraph({ break: 1 }),
                new Paragraph({
                  children: [new TextRun({
                    text: reportType === "HSE" ? "9. Conclusion" : "7. Conclusion",
                    font: "Montserrat",
                    color: "#307260",
                    size: 25,
                    bold: true,
                  })],
                  break: 1.,
                  indent: {
                    left: 300,
                    right: 1000
                  }
                }),
                new Paragraph({ break: 1 }), // Line break after the heading


                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        // fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        // left: 200,
                                        // right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...conclusionParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },

                }),
                new Paragraph({ break: 1 }),
                new Paragraph({ break: 1 }),
                new Paragraph({ break: 1 }),
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [new TextRun({
                    text: `"Momentum - Empowering Progress"`,
                    font: "Montserrat",
                    color: "#307260",
                    size: 40,
                    bold: true,
                  })],
                  break: 1
                }),
              ],

            },
          ] : []),

          //conlusion for HSE 
          ...(reportType === "HSE" ? [
            {

              properties: {
                page: {
                  orientation: PageOrientation.PORTRAIT,
                  // size: {
                  //   width: 16838,   // 29.7 cm
                  //   height: 11906,  // 21 cm
                  // },
                  margin: {
                    top: 500,
                    left: 500,
                    right: 500
                  }
                }
              },
              children: [
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: {
                            size: 100, // Adjust width as needed
                            type: WidthType.PERCENTAGE,
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: ``,
                                  size: 30,
                                  font: "Montserrat",
                                  color: "#ffffff", // Adjust text color for visibility
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: base64logo,
                                  transformation: {
                                    width: 120,
                                    height: 40,
                                  },
                                }),
                              ],
                            }),
                          ],
                          verticalAlign: "center",
                        }),
                      ],
                      tableHeader: true,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({
                  children: [new TextRun("")],
                  break: 1
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          shading: {
                            type: "clear",
                            color: "auto",
                          },
                          margins: {
                            left: 300,   // 1 inch left gap
                            right: 300,  // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Conclusion",
                                  font: "Montserrat",
                                  color: "#307268",
                                  size: 28,
                                  bold: true,
                                }),
                              ],
                              break: 1,
                            }),

                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({ break: 1 }),
                // Outer table for left/right spacing
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 100, type: WidthType.PERCENTAGE },
                          margins: {
                            left: 300,  // 1 inch left gap
                            right: 300, // 1 inch right gap
                          },
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.NONE },
                            left: { style: BorderStyle.NONE },
                            right: { style: BorderStyle.NONE },
                          },
                          children: [
                            // Inner table with yellow background
                            new Table({
                              rows: [
                                new TableRow({
                                  children: [
                                    new TableCell({
                                      shading: {
                                        type: "clear",
                                        color: "auto",
                                        fill: "fff8dc", // Light cream-yellow background
                                      },
                                      margins: {
                                        top: 200,    // padding inside yellow box
                                        bottom: 200,
                                        left: 200,
                                        right: 200,
                                      },
                                      borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                      },
                                      children: [
                                        ...conclusionParagraph3,
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                              width: { size: 100, type: WidthType.PERCENTAGE },
                              borders: {
                                top: { style: BorderStyle.NONE },
                                bottom: { style: BorderStyle.NONE },
                                left: { style: BorderStyle.NONE },
                                right: { style: BorderStyle.NONE },
                                insideHorizontal: { style: BorderStyle.NONE },
                                insideVertical: { style: BorderStyle.NONE },
                              },
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE },
                  },
                }),
                new Paragraph({ break: 1 }),
                new Paragraph({ break: 1 }),
                new Paragraph({ break: 1 }),
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [new TextRun({
                    text: `"Momentum - Empowering Progress"`,
                    font: "Montserrat",
                    color: "#307260",
                    size: 40,
                    bold: true,
                  })],
                  break: 1
                }),


              ],
            },
          ] : []),

          //           {
          //             properties: {
          //               page: {
          //                 orientation: PageOrientation.PORTRAIT,
          //       size: {
          //         width: 16838,   // 29.7 cm
          //         height: 11906,  // 21 cm
          //       },
          //                 margin: {
          //                   top: 500,
          //                   left: 500,
          //                   right: 500
          //                 }
          //               }
          //             },
          //             children: [
          //               new Table({
          //                 rows: [
          //                   new TableRow({
          //                     children: [
          //                       new TableCell({
          //                         width: {
          //                           size: 100, // Adjust width as needed
          //                           type: WidthType.PERCENTAGE,
          //                         },
          //                         children: [
          //                           new Paragraph({
          //                             children: [
          //                               new TextRun({
          //                                 text: ``,
          //                                 size: 30,
          //                                 font: "Montserrat",
          //                                 color: "#ffffff",
          //                               }),
          //                             ],
          //                           }),
          //                         ],
          //                         verticalAlign: "center",
          //                       }),
          //                       new TableCell({
          //                         children: [
          //                           new Paragraph({
          //                             children: [
          //                               new ImageRun({
          //                                 data: base64logo,
          //                                 transformation: {
          //                                   width: 120,
          //                                   height: 40,
          //                                 },
          //                               }),
          //                             ],
          //                           }),
          //                         ],
          //                         verticalAlign: "center",
          //                       }),
          //                     ],
          //                     tableHeader: true,
          //                   }),
          //                 ],
          //                 width: {
          //                   size: 100,
          //                   type: WidthType.PERCENTAGE,
          //                 },
          //                 borders: {
          //                   top: { style: BorderStyle.NONE },
          //                   bottom: { style: BorderStyle.NONE },
          //                   left: { style: BorderStyle.NONE },
          //                   right: { style: BorderStyle.NONE },
          //                   insideHorizontal: { style: BorderStyle.NONE },
          //                   insideVertical: { style: BorderStyle.NONE },
          //                 },
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 1
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun({
          //                   text: reportType === "HSE" ? "9. Conclusion" : "7. Conclusion",
          //                   font: "Montserrat",
          //                   color: "#307260",
          //                   size: 25,
          //                   bold: true,
          //                 })],
          //                 break: 1.,
          //                 indent:{
          //                   left:1000,
          //                   right:1000
          //                 }
          //               }),
          //               new Paragraph({ break: 1 }), // Line break after the heading


          // new Table({
          //   rows: [
          //     new TableRow({
          //       children: [
          //         new TableCell({
          //           width: { size: 100, type: WidthType.PERCENTAGE },
          //           margins: {
          //             left: 300,  // 1 inch left gap
          //             right: 300, // 1 inch right gap
          //           },
          //           borders: {
          //             top: { style: BorderStyle.NONE },
          //             bottom: { style: BorderStyle.NONE },
          //             left: { style: BorderStyle.NONE },
          //             right: { style: BorderStyle.NONE },
          //           },
          //           children: [
          //             // Inner table with yellow background
          //             new Table({
          //               rows: [
          //                 new TableRow({
          //                   children: [
          //                     new TableCell({
          //                       shading: {
          //                         type: "clear",
          //                         color: "auto",
          //                         fill: "fff8dc", // Light cream-yellow background
          //                       },
          //                       margins: {
          //                         top: 200,    // padding inside yellow box
          //                         bottom: 200,
          //                         left: 200,
          //                         right: 200,
          //                       },
          //                       borders: {
          //                         top: { style: BorderStyle.NONE },
          //                         bottom: { style: BorderStyle.NONE },
          //                         left: { style: BorderStyle.NONE },
          //                         right: { style: BorderStyle.NONE },
          //                       },
          //                       children: [
          //                         ...conclusionParagraph3, 
          //                       ],
          //                     }),
          //                   ],
          //                 }),
          //               ],
          //               width: { size: 100, type: WidthType.PERCENTAGE },
          //               borders: {
          //                 top: { style: BorderStyle.NONE },
          //                 bottom: { style: BorderStyle.NONE },
          //                 left: { style: BorderStyle.NONE },
          //                 right: { style: BorderStyle.NONE },
          //                 insideHorizontal: { style: BorderStyle.NONE },
          //                 insideVertical: { style: BorderStyle.NONE },
          //               },
          //             }),
          //           ],
          //         }),
          //       ],
          //     }),
          //   ],
          //   width: { size: 100, type: WidthType.PERCENTAGE },
          //   borders: {
          //     top: { style: BorderStyle.NONE },
          //     bottom: { style: BorderStyle.NONE },
          //     left: { style: BorderStyle.NONE },
          //     right: { style: BorderStyle.NONE },
          //     insideHorizontal: { style: BorderStyle.NONE },
          //     insideVertical: { style: BorderStyle.NONE },
          //   },
          // }),

          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 5
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 5
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 5
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 5
          //               }),
          //               new Paragraph({
          //                 children: [new TextRun("")],
          //                 break: 5
          //               }),
          //               new Paragraph({
          //                 alignment: AlignmentType.CENTER,
          //                 children: [new TextRun({
          //                   text: `"Momentum - Empowering Progress"`,
          //                   font: "Montserrat",
          //                   color: "#307260",
          //                   size: 40,
          //                   bold: true,
          //                 })],
          //                 break: 1
          //               }),
          //             ],
          //           },
        ],
        numbering: {
          config: [
            {
              reference: "my-cool-numbering",
              levels: [
                {
                  level: 0,
                  format: "decimal", // <--- This is key for 1), 2), etc.
                  text: "%1)",
                  alignment: AlignmentType.LEFT,
                  style: {
                    paragraph: {
                      indent: {
                        left: 300,   // shift list slightly from left
                        hanging: 200, // text wraps nicely after the number
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
      });

      return doc;
    } catch (error) {
      console.error("Error creating Word document:", error);
      return null;
    }
  };
  // Function to create breaks (empty lines)
  const createBreaks = (num) => {
    return Array(num).fill().map(() => new Paragraph({ children: [new TextRun("\n")] }));
  };
  const exportToWord = async () => {
    setLoading(true);
    // await fetchBase64Images();
    const doc = createWordDocument();

    if (doc) {
      try {
        doc.creator = "Your Name";
        doc.title = "Your Document Title";
        doc.description = "Your Document Description";
        doc.keywords = "Keyword1, Keyword2";
        // console.log("____doc", doc)
        const blob = await Packer.toBlob(doc);
        // console.log("____blob", blob)
        saveAs(
          blob,
          `${ReportUID}.docx`
        );
      } catch (error) {
        console.log("Error exporting to Word:", error);
      } finally {
        setLoading(false);
      }
    } else {
      console.error("Document is null. Export canceled.");
    }
  };

  return (
    <div>
      <button
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          background: isSaved ? "#efc71d" : "lightgrey",
          borderStyle: "none",
          borderRadius: "5px",
          fontWeight: "bold",
          padding: "11px 18px",
          textTransform: "uppercase",
          color: "white",
          fontSize: "1rem",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)"
        }}
        disabled={!isSaved || loading}
        onClick={exportToWord}
      >
        {loading ? 'Please wait...' : 'EXPORT TO WORD'} &nbsp;
        <FileDownloadIcon fontSize="small" />
      </button>
    </div>
  );
};

export default ExportWordDoc;